webpackJsonp([1],{

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "/2Gk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"homebox"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"racelistbox"},[_c('div',{staticClass:"rightbox"},[_c('div',{staticClass:"OneyearBox"},[_c('div',{staticClass:"monthbox"},_vm._l((_vm.months),function(month){return _c('div',{key:month.value,staticClass:"monthitem",attrs:{"data-month":month.value}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('div',{staticClass:"monthminbox"},[_c('p',[_vm._v(_vm._s(month.name))]),_vm._v(" "),(_vm.monthIsHaveRace[month.value])?_c('div',{staticClass:"monthhaveraceicon"}):_vm._e()])])])}),0),_vm._v(" "),_c('div',{staticClass:"yearbox"},[_c('div',{staticClass:"yearitem"},[_c('p',[_vm._v(_vm._s(_vm.currentYear)+"年")])])])]),_vm._v(" "),_c('div',{staticClass:"OneyearBox"},[_c('div',{staticClass:"monthbox"},_vm._l((_vm.months2),function(month){return _c('div',{key:month.value,staticClass:"monthitem",attrs:{"data-month":month.value}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('div',{staticClass:"monthminbox"},[_c('p',[_vm._v(_vm._s(month.name))]),_vm._v(" "),(_vm.month2IsHaveRace[month.value])?_c('div',{staticClass:"monthhaveraceicon"}):_vm._e()])])])}),0),_vm._v(" "),_c('div',{staticClass:"yearbox"},[_c('div',{staticClass:"yearitem"},[_c('p',[_vm._v(_vm._s(_vm.currentYear2)+"年")])])])])]),_vm._v(" "),_c('div',{staticClass:"leftbox"},_vm._l((_vm.raceList),function(item){return _c('div',{key:item.id,staticClass:"racebox"},[_c('div',{staticClass:"racetitle"},[_vm._v(_vm._s(item.raceName))]),_vm._v(" "),_c('div',{staticClass:"raceimg"},[_c('img',{attrs:{"src":item.raceImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"racedes"},[_vm._v("\n            "+_vm._s(item.raceContent)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"raceprice"},[_vm._v(_vm._s(item.minprice)+"起")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.gotoRacedes(item.id)}}},[_c('div',{staticClass:"racebtn"},[_vm._v("了解详情")])]),_vm._v(" "),_c('div',{staticClass:"race-time"},[_c('div',{staticClass:"race-time-item"},[_c('div',{staticClass:"race-time-item-title"},[_vm._v("比赛时间:"+_vm._s(item.raceDate))]),_vm._v(" "),_c('div',{staticClass:"race-time-item-title"},[_vm._v("比赛地点:"+_vm._s(item.countryName)+"-"+_vm._s(item.cityName))])])])])}),0)])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"haedboximg"},[_c('img',{attrs:{"src":__webpack_require__("pgUL"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "06MH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "16gr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "clubdes",
  data: function data() {
    var _this = this;

    return {
      imageurl: BaseUrl,
      clubid: 1,
      clubdes: {},
      isshowtech: true,
      isshownews: true,
      swiperOption: {
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        // slidesPerView: 'auto',
        // centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.57,
        slidesPerView: 2.5,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          _this.page = swiper.realIndex + 1;
          _this.index = swiper.realIndex;
        }
      }
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Home"
      });
    },

    GetClueDes: function GetClueDes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                params = {
                  id: _this2.clubid
                };
                url = "https://ttserver.aizhuotice.online/api/v1/clubInfo";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context.sent;


                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response);
                if (_this2.response.code == 200) {
                  // console.log(this.response.data);
                  _this2.clubdes = _this2.response.data;
                  console.log(_this2.clubdes);
                  if (_this2.clubdes.clubCoachList.length > 0) {
                    _this2.isshowtech = true;
                  } else {
                    _this2.isshowtech = false;
                  }
                  // console.log(this.clubdes.clubName);
                } else {}
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this2.error);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  created: function created() {
    this.clubid = this.$route.params.id;
    // console.log(this.$route.params);
    console.log(this.clubid);
    console.log("BaseUrl=" + BaseUrl);
    if (this.clubid == null) {
      this.clubid = 1;
    }
    this.GetClueDes();
  }
});

/***/ }),

/***/ "1sot":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "20Rq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopdes_vue__ = __webpack_require__("isE9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8eafe22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopdes_vue__ = __webpack_require__("kGmR");
function injectStyle (ssrContext) {
  __webpack_require__("gMMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8eafe22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopdes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8eafe22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopdes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2EVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "shop",
  data: function data() {
    var _this = this;

    return {
      shopid: "",
      msg: "",
      brandList: [],
      shopitemlist: {},

      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        // slidesPerView: 'auto',
        // centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.8,
        // pagination: '.swiper-pagination',
        slidesPerView: 3,
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 60,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          //这个位置放swiper的回调方法
          _this.page = swiper.realIndex + 1;
          _this.index = swiper.realIndex;
        }
      }
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoShopDes: function gotoShopDes(id) {
      console.log(id);
      this.$router.push({
        name: "shopdes",
        params: {
          id: id
        }
      });
    },
    CheckBandList: function CheckBandList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                params = {
                  page: 1,
                  size: 10
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/page/brand";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context.sent;


                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this2.response.code);
                if (_this2.response.code == 200) {
                  // console.log(this.response.data);
                  _this2.brandList = _this2.response.data.data;

                  console.log(_this2.brandList);
                  _this2.brandList.forEach(function (element) {

                    _this2.CheckShopList(element.id);
                  });
                } else {}
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this2.error);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 13]]);
      }))();
    },
    CheckShopList: function CheckShopList(bId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, url, response, name;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // 清空之前的响应和错误信息
                _this3.response = null;
                _this3.error = null;
                params = {
                  page: 1,
                  size: 10,
                  brandId: bId
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/page";
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context2.sent;


                // 处理成功响应
                _this3.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response.code);
                if (_this3.response.code == 200) {
                  console.log(_this3.response.data.data);
                  // this.brandList = this.response.data.data;
                  // const item1 = {
                  //   bId: this.response.data.data,
                  // };
                  name = bId;

                  _this3.$set(_this3.shopitemlist, name, _this3.response.data.data);
                  // console.log(this.shopitemlist[name]);
                  _this3.shopitemlist[name].forEach(function (element) {
                    element.prodContent = element.prodContent.replace(/<img[^>]*>/g, "");
                  });
                } else {}
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this3.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this3.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this3.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }
                console.log(_this3.error);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.CheckBandList();
    this.shopitemlist = {};
  },
  created: function created() {}
});

/***/ }),

/***/ "2Tz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"hometiebox2"},[_c('div',{staticClass:"hometieboximg"},[_c('img',{attrs:{"src":__webpack_require__("hM9b"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"hometiebtnimg"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoRegTiePage}},[_c('img',{attrs:{"src":__webpack_require__("8y4l"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"cluebox"},[_vm._m(1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClue1),expression:"showClue1"}],staticClass:"myclue1"},[_c('div',{staticClass:"mycluebg"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoClublist}},[_c('img',{attrs:{"src":__webpack_require__("8s2u"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"myclue1-click",on:{"mouseover":_vm.handleMouseClue1}},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoClublist}},[_c('img',{attrs:{"src":__webpack_require__("k8gW"),"alt":""}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClue2),expression:"showClue2"}],staticClass:"myclue2"},[_c('div',{staticClass:"mycluebg"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoRacelist}},[_c('img',{attrs:{"src":__webpack_require__("ZnGw"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"myclue2-click",on:{"mouseover":_vm.handleMouseClue2}},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoClublist}},[_c('img',{attrs:{"src":__webpack_require__("jNq+"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"racetypebox"},[_c('div',{staticClass:"racetype1"},[_c('div',{staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype1}},[_c('img',{attrs:{"src":__webpack_require__("PC6g"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRtype1),expression:"showRtype1"}],staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype1,"mouseout":_vm.handleMouseoutRtype1}},[_c('img',{attrs:{"src":__webpack_require__("P10X"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"racetype2"},[_c('div',{staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype2}},[_c('img',{attrs:{"src":__webpack_require__("XwAm"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRtype2),expression:"showRtype2"}],staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype2,"mouseout":_vm.handleMouseoutRtype2}},[_c('img',{attrs:{"src":__webpack_require__("cmCH"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"racetype3"},[_c('div',{staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype3}},[_c('img',{attrs:{"src":__webpack_require__("elte"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRtype3),expression:"showRtype3"}],staticClass:"racetypeone",on:{"mouseover":_vm.handleMouseRtype3,"mouseout":_vm.handleMouseoutRtype3}},[_c('img',{attrs:{"src":__webpack_require__("6vKa"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"matchbox"},[_vm._m(2),_vm._v(" "),_c('swiper',{ref:"mySwiper",staticClass:"matchswiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('div',{staticClass:"swiperitem"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.gotoRacelist()}}},[_c('img',{attrs:{"src":__webpack_require__("OQjs")}})])])]),_vm._v(" "),_vm._l((_vm.raceList),function(item){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"swiperitem"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.gotoRacedetail(item.id)}}},[_c('img',{attrs:{"src":__webpack_require__("ElVu")}}),_vm._v(" "),_c('div',{staticClass:"racemask"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.raceName))]),_vm._v(" "),_c('p',{staticClass:"countryname"},[_vm._v(_vm._s(item.countryName))])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-scrollbar",attrs:{"slot":"scrollbar"},slot:"scrollbar"})],2)],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"posbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos1),expression:"showpos1"}],staticClass:"mypos1"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"mypos1-click",on:{"mouseover":_vm.handleMouseposbtn,"mouseout":_vm.handleMouseoutPosbtn}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showposbtn),expression:"!showposbtn"}],attrs:{"src":__webpack_require__("V6Uh"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showposbtn),expression:"showposbtn"}],staticClass:"posbtn2",attrs:{"src":__webpack_require__("HmGK"),"alt":""}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos2),expression:"showpos2"}],staticClass:"mypos2"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"mypos1-click",on:{"mouseover":_vm.handleMouseposbtn,"mouseout":_vm.handleMouseoutPosbtn}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showposbtn),expression:"!showposbtn"}],attrs:{"src":__webpack_require__("V6Uh"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showposbtn),expression:"showposbtn"}],staticClass:"posbtn2",attrs:{"src":__webpack_require__("HmGK"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"posline"},[_c('div',{staticClass:"myposline1",on:{"mouseover":_vm.handleMousepos1}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos2),expression:"showpos2"}],attrs:{"src":__webpack_require__("WkIM"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos1),expression:"showpos1"}],attrs:{"src":__webpack_require__("r4Jm"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"myposline2",on:{"mouseover":_vm.handleMousepos2}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos1),expression:"showpos1"}],attrs:{"src":__webpack_require__("WkIM"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showpos2),expression:"showpos2"}],attrs:{"src":__webpack_require__("r4Jm"),"alt":""}})])])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hometiebox"},[_c('div',{staticClass:"hometieboximg"},[_c('img',{attrs:{"src":__webpack_require__("A/kV"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cluebg"},[_c('img',{attrs:{"src":__webpack_require__("8LnQ"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matchbg"},[_c('img',{attrs:{"src":__webpack_require__("u/hN"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friendbox"},[_c('div',{staticClass:"friendbg"},[_c('img',{attrs:{"src":__webpack_require__("2WIz"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myposbg"},[_c('img',{attrs:{"src":__webpack_require__("2yL6"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myposbg"},[_c('img',{attrs:{"src":__webpack_require__("XzAS"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2WIz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/friendbg.4956f83.jpg";

/***/ }),

/***/ "2yL6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/pos1img.2d8bf0e.jpg";

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c7d5a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("2Tz2");
function injectStyle (ssrContext) {
  __webpack_require__("Phft")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32c7d5a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32c7d5a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5s46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegTie_vue__ = __webpack_require__("nGHk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d25e3fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegTie_vue__ = __webpack_require__("vY9p");
function injectStyle (ssrContext) {
  __webpack_require__("S3lf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d25e3fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegTie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d25e3fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegTie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Ten":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6cdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setpage"},[_c('div',{staticClass:"settop"}),_vm._v(" "),_c('div',{staticClass:"leftbox"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"setitem",on:{"click":function($event){return _vm.gotoMyInve()}}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"setitem setitem2",on:{"click":function($event){return _vm.gotoInve()}}},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"setitem",on:{"click":function($event){return _vm.gotoHelp()}}},[_vm._m(3)])]),_vm._v(" "),(_vm.helpshow==true)?_c('div',{staticClass:"helpbox",on:{"click":function($event){return _vm.hideHelp()}}}):_vm._e(),_vm._v(" "),(_vm.inveshow==true)?_c('div',{staticClass:"invebox"},[_c('input',{ref:"add_inve",staticClass:"inve-input",attrs:{"type":"text","name":"name","maxlength":"10","min":"2","max":"10","placeholder":"输入邀请"}}),_vm._v(" "),_c('div',{staticClass:"inte-btn",on:{"click":function($event){return _vm.hideInve()}}})]):_vm._e(),_vm._v(" "),(_vm.logshow==true)?_c('div',{staticClass:"logbox"},[_c('div',{staticClass:"msgbox"},[_vm._v(_vm._s(_vm.logs))]),_vm._v(" "),_c('div',{staticClass:"log-btn",on:{"click":function($event){return _vm.hidelog()}}})]):_vm._e(),_vm._v(" "),(_vm.myinveshow==true)?_c('div',{staticClass:"myinvebox"},[_c('div',{staticClass:"msgbox"},[_vm._v(_vm._s(_vm.myinves))]),_vm._v(" "),_c('div',{staticClass:"log-btn",on:{"click":function($event){return _vm.hideMyinve()}}})]):_vm._e(),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setitem setitem2"},[_c('p',[_c('span',[_vm._v("通")]),_vm._v("知中心")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("邀")]),_vm._v("请奖励")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("输")]),_vm._v("入邀请码")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("问")]),_vm._v("题反馈")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6paN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"clublistbox"},[_c('div',{staticClass:"clubtitle"},[_vm._v("\n      俱乐部列表\n    ")]),_vm._v(" "),_vm._l((_vm.clubList),function(item){return _c('div',{key:item.id,staticClass:"clubbox"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.gotoClubdes(item.id)}}},[_c('div',{staticClass:"clubminbox"},[_c('div',{staticClass:"leftbox"},[_c('div',{staticClass:"racetitle"},[_vm._v(_vm._s(item.clubName))]),_vm._v(" "),_c('div',{staticClass:"clubdes"},[_vm._v("\n              "+_vm._s(item.introduce)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"racebtn"},[_vm._v("查看此俱乐部 >")])]),_vm._v(" "),_c('div',{staticClass:"midbox"},[_c('p',[_vm._v("地址："+_vm._s(item.address))]),_vm._v(" "),_c('p',[_vm._v("营业时间："+_vm._s(item.openTime))]),_vm._v(" "),_c('p',[_vm._v("联系电话："+_vm._s(item.userPhone))])]),_vm._v(" "),_c('div',{staticClass:"rightbox"},[_c('div',{staticClass:"raceimg"},[_c('img',{attrs:{"src":item.clubUrl,"alt":""}})])])])])])})],2),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6vKa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type3hover.e69dea8.jpg";

/***/ }),

/***/ "7iae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("PIy8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30721b10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("jADk");
function injectStyle (ssrContext) {
  __webpack_require__("xxP+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30721b10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "80lN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"mypagebox"},[_c('div',{staticClass:"leftbox"},[_c('div',{staticClass:"mypageboxitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.ShowMyinfo()}}},[_c('p',[_vm._v("我的信息")])])]),_vm._v(" "),_c('div',{staticClass:"mypageboxitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.ShowMyorder()}}},[_c('p',[_vm._v("我的订单")])])]),_vm._v(" "),_c('div',{staticClass:"mypageboxitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.ShowMytie()}}},[_c('p',[_vm._v("百万铁人")])])]),_vm._v(" "),_c('div',{staticClass:"mypageboxitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.ShowMycourse()}}},[_c('p',[_vm._v("我的课程")])])]),_vm._v(" "),_c('div',{staticClass:"mypageboxitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.ShowMyrace()}}},[_c('p',[_vm._v("我的赛事")])])])]),_vm._v(" "),_c('div',{staticClass:"rightbox"},[(_vm.showtype == 1)?_c('div',{staticClass:"rightsubbox"},[_c('p',[_vm._v("我的信息")])]):_vm._e(),_vm._v(" "),(_vm.showtype == 2)?_c('div',{staticClass:"rightsubbox"},[_c('p',[_vm._v("我的订单")])]):_vm._e(),_vm._v(" "),(_vm.showtype == 3)?_c('div',{staticClass:"rightsubbox"},[_c('p',[_vm._v("百万铁人")])]):_vm._e(),_vm._v(" "),(_vm.showtype == 4)?_c('div',{staticClass:"rightsubbox"},[_c('p',[_vm._v("我的课程")])]):_vm._e(),_vm._v(" "),(_vm.showtype == 5)?_c('div',{staticClass:"rightsubbox"},[_c('p',[_vm._v("我的赛事")])]):_vm._e()])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8LnQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/cluebg.ecce0a8.jpg";

/***/ }),

/***/ "8s2u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/club-1.2619512.jpg";

/***/ }),

/***/ "8y4l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/tiebtn2.3572655.png";

/***/ }),

/***/ "8zuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"shopitembox"},[_c('div',{staticClass:"topbox"},[_c('div',{staticClass:"leftbox"},[_c('img',{attrs:{"src":_vm.showsku.skuImage,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.shopitem.prodName))]),_vm._v(" "),_c('p',{staticClass:"itemtype"},[_vm._v(_vm._s(_vm.shopitem.typeCode))]),_vm._v(" "),_c('p',{staticClass:"itemprice"},[_vm._v("￥"+_vm._s(_vm.price2))]),_vm._v(" "),_c('p',{staticClass:"itemprice"},[_vm._v(_vm._s(_vm.typename))])]),_vm._v(" "),_c('div',{staticClass:"rightbox"},[_c('p',[_vm._v("收货地址")]),_vm._v(" "),_c('div',{staticClass:"reginputboxyear"},[(_vm.isChinaSelected)?_c('p',[_vm._v("省")]):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.stationName),expression:"formData.stationName"}],attrs:{"id":"Province"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "stationName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateProvince]}},_vm._l((_vm.ProvinceList),function(province){return _c('option',{key:province.name,domProps:{"value":province.name}},[_vm._v("\n              "+_vm._s(province.name)+"\n            ")])}),0):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('p',[_vm._v("市")]):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.cityName),expression:"formData.cityName"}],attrs:{"id":"City"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "cityName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateCity]}},_vm._l((_vm.CityList),function(city){return _c('option',{key:city.name,domProps:{"value":city.name}},[_vm._v("\n              "+_vm._s(city.name)+"\n            ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.address),expression:"formData.address"}],attrs:{"type":"text","placeholder":"地址"},domProps:{"value":(_vm.formData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "address", $event.target.value)}}})])]),_vm._v(" "),_c('p',{staticClass:"righttitle"},[_vm._v("手机号")]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('div',{staticClass:"reginputbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],attrs:{"type":"text","placeholder":"请输入手机号"},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('p',{staticClass:"righttitle"},[_vm._v("收货人")]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('div',{staticClass:"reginputbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],attrs:{"type":"text","placeholder":"请输入收货人"},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}})])]),_vm._v(" "),_c('p',{staticClass:"righttitle"},[_vm._v("数量")]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('div',{staticClass:"reginputbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.buynum),expression:"formData.buynum"}],attrs:{"type":"text","placeholder":"请输入数量"},domProps:{"value":(_vm.formData.buynum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "buynum", $event.target.value)}}})])]),_vm._v(" "),_c('p',{staticClass:"righttitle"},[_vm._v("\n          总价："),_c('span',[_vm._v("￥"+_vm._s(_vm.price2 * _vm.formData.buynum))])]),_vm._v(" "),_c('div',{staticClass:"buyitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.handlebuybtn}},[_vm._v("购买")])])])])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9PZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A/kV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/tie1.3eb21e5.jpg";

/***/ }),

/***/ "AJIP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AdJh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/typebg.698709e.jpg";

/***/ }),

/***/ "B+zM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setpage_vue__ = __webpack_require__("KTf5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_142cb294_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setpage_vue__ = __webpack_require__("6cdy");
function injectStyle (ssrContext) {
  __webpack_require__("Tv8t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-142cb294"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_142cb294_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BVHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clublist_vue__ = __webpack_require__("CwUf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04baa2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clublist_vue__ = __webpack_require__("6paN");
function injectStyle (ssrContext) {
  __webpack_require__("tZwI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04baa2de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clublist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04baa2de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clublist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CwUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "clublist",
  data: function data() {
    return {
      msg: "",
      clubList: [],
      bgColor: "#181818" // 初始背景颜色
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: (_methods = {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Home"
      });
    },
    gotoClubdes: function gotoClubdes() {
      this.$router.push({
        name: "clubdes"
      });
    }

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "gotoClubdes", function gotoClubdes(id) {
    console.log("clubid=" + id);
    this.$router.push({
      name: "clubdes",
      params: { id: id }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "CheckClubList", function CheckClubList() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              // 清空之前的响应和错误信息
              _this.response = null;
              _this.error = null;
              params = {
                page: 1,
                size: 10
              };
              url = "https://ttserver.aizhuotice.online/api/v1/clubInfo/page";
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                params: params,
                headers: {
                  "Content-Type": "application/json"
                  // token: this.token,
                }
              });

            case 7:
              response = _context.sent;


              // 处理成功响应
              _this.response = response.data; // 将返回的数据存储到组件状态
              console.log(_this.response);
              if (_this.response.code == 200) {
                // console.log(this.response.data);
                _this.clubList = _this.response.data.data;

                console.log(_this.clubList.length);

                console.log(_this.raceList);

                _this.clubList.forEach(function (element) {
                  element.clubUrl = element.clubImage;
                });
                // this.isShowLoginBtn = false;
              } else {
                  // this.isShowLoginBtn = true;
                }
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

              // 处理请求错误
              if (_context.t0.response) {
                // 服务器返回了错误响应（例如 4xx 或 5xx）
                _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
              } else if (_context.t0.request) {
                // 请求已发出，但没有收到响应
                _this.error = "未收到服务器响应";
              } else {
                // 其他错误
                _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
              }
              console.log(_this.error);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 13]]);
    }))();
  }), _methods),
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.CheckClubList();
  },
  created: function created() {
    // this.CheckClubList();
  }
});

/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_global_css__ = __webpack_require__("ORax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_less_global_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import WawaList from "./../components/block/wawalist";


 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Index",
  data: function data() {
    var _this = this;

    return {
      showClue1: true,
      showClue2: false,
      showRtype1: false,
      showRtype2: false,
      showRtype3: false,
      showposbtn: false,
      showpos1: true,
      showpos2: false,
      msg: "",
      token: "",
      response: null,
      error: null,
      isShowLoginBtn: true,
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        scrollbar: '.swiper-scrollbar',
        scrollbarHide: false,
        // slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.8,
        // pagination: '.swiper-pagination',
        slidesPerView: 2.5,
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 60,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          //这个位置放swiper的回调方法
          _this.page = swiper.realIndex + 1;
          _this.index = swiper.realIndex;
        }
      },
      raceList: []
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"],
    footerBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Home"
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: "mypage"
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: "Setpage"
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: "Rankpage"
      });
    },
    gotoRegTiePage: function gotoRegTiePage() {
      this.$router.push({
        name: "regTiePage"
      });
    },
    gotoClublist: function gotoClublist() {
      this.$router.push({
        name: "clublist"
      });
    },
    gotoRacelist: function gotoRacelist() {
      this.$router.push({
        name: "racelist"
      });
    },
    gotoRacedetail: function gotoRacedetail(id) {
      this.$router.push({
        name: "racedes",
        params: { raceid: id }
      });
    },
    handleMouseClue1: function handleMouseClue1() {
      // console.log("handleMouseClue1");
      this.showClue1 = false;
      this.showClue2 = true;
    },
    handleMouseClue2: function handleMouseClue2() {
      // console.log("handleMouseClue2");
      this.showClue1 = true;
      this.showClue2 = false;
    },
    handleMouseRtype1: function handleMouseRtype1() {
      // console.log("handleMouseRtype1");
      this.showRtype1 = true;
    },
    handleMouseoutRtype1: function handleMouseoutRtype1() {
      // console.log("handleMouseoutRtype1");
      this.showRtype1 = false;
    },
    handleMouseRtype2: function handleMouseRtype2() {
      // console.log("handleMouseRtype2");
      this.showRtype2 = true;
    },
    handleMouseoutRtype2: function handleMouseoutRtype2() {
      // console.log("handleMouseoutRtype2");/
      this.showRtype2 = false;
    },
    handleMouseRtype3: function handleMouseRtype3() {
      // console.log("handleMouseRtype3");
      this.showRtype3 = true;
    },
    handleMouseoutRtype3: function handleMouseoutRtype3() {
      // console.log("handleMouseoutRtype3");
      this.showRtype3 = false;
    },
    handleMousepos1: function handleMousepos1() {
      // console.log("handleMousepos1");
      this.showpos1 = true;
      this.showpos2 = false;
    },
    handleMouseposbtn: function handleMouseposbtn() {
      // console.log("handleMouseRtype3");
      this.showposbtn = true;
    },
    handleMouseoutPosbtn: function handleMouseoutPosbtn() {
      // console.log("handleMouseoutRtype3");
      this.showposbtn = false;
    },
    handleMousepos2: function handleMousepos2() {
      // console.log("handleMousepos2");
      this.showpos1 = false;
      this.showpos2 = true;
    },

    CheckRaceList: function CheckRaceList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                params = {
                  page: 1,
                  size: 10
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfo/page";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context.sent;


                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response);
                if (_this2.response.code == 200) {
                  _this2.raceList = _this2.response.data.data;
                  // console.log(this.raceList);

                  // this.isShowLoginBtn = false;
                } else {
                    // this.isShowLoginBtn = true;
                  }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this2.error);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
    this.token = localStorage.getItem("token");
    // if (this.token) {
    //   this.CheckUserbtn();
    // }
    this.CheckRaceList();
  },
  created: function created() {}
});

/***/ }),

/***/ "ElVu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/raceitem2.f3fb6f8.jpg";

/***/ }),

/***/ "F48L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FN+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myhead_vue__ = __webpack_require__("ykli");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b2fd10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myhead_vue__ = __webpack_require__("c7iU");
function injectStyle (ssrContext) {
  __webpack_require__("xWh3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14b2fd10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myhead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b2fd10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myhead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_block_footer__ = __webpack_require__("VIIK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import WawaList from './../components/block/wawalist'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    var _this = this;

    return {
      msg: '',
      wawadata: [
        // { id: 0, text: ' 轻松熊',img:require('../assets/images/bear.jpg'),price:'33',status:'1' },
        // { id: 1,text: ' 轻松熊1',img:require('../assets/images/bear.jpg'),price:'34',status:'0'},

      ],
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true  
        notNextTick: true,
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 30,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          //这个位置放swiper的回调方法  
          _this.page = swiper.realIndex + 1;
          _this.index = swiper.realIndex;
        }
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"],
    footerBlock: __WEBPACK_IMPORTED_MODULE_1__components_block_footer__["a" /* default */]
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: 'Home'
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: 'mypage'
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: 'Setpage'
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: 'Rankpage'
      });
    },
    wxpage: function wxpage(id) {
      // var address = 'mywawa';
      // var call_back_uri = "http%3A%2F%2Fwww.legendream.cn%2F"+address+"%2Findex1.php";

      // var grant_url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb575a2aa9f43050&redirect_uri="+call_back_uri+"&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
      // location.href=grant_url;

    },
    getUserInfo: function getUserInfo() {}

  },
  mounted: function mounted() {
    // you can use current swiper instance object to do something(swiper methods)
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //console.log('this is current swiper instance object', this.swiper)
    this.swiper.slideTo(3, 1000, false);
  },
  created: function created() {
    // this.getUserInfo();
  }
});

/***/ }),

/***/ "G4DH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/head1.e45d609.jpg";

/***/ }),

/***/ "GueC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "courselist",
  data: function data() {
    var _this = this;

    return {
      shopid: "",
      msg: "",
      brandList: [],
      shopitemlist: {},
      showCourseDes: false,

      swiperOption: {
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.8,
        slidesPerView: 3,
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          _this.page = swiper.realIndex + 1;
          _this.index = swiper.realIndex;
        }
      }
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {},
  methods: {
    gotoShopDes: function gotoShopDes(id) {
      console.log(id);
      this.showCourseDes = true;
      //   this.$router.push({
      //     name: "shopdes",
      //     params: {
      //       id: id,
      //     },
      //   });
    },
    closeCoursedesbox: function closeCoursedesbox() {
      this.showCourseDes = false;
    },
    CheckBandList: function CheckBandList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                params = {
                  page: 1,
                  size: 10
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/page/brand";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context.sent;


                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this2.response.code);
                if (_this2.response.code == 200) {
                  // console.log(this.response.data);
                  _this2.brandList = _this2.response.data.data;

                  console.log(_this2.brandList);
                  _this2.brandList.forEach(function (element) {

                    _this2.CheckShopList(element.id);
                  });
                } else {}
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this2.error);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 13]]);
      }))();
    },
    CheckShopList: function CheckShopList(bId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, url, response, name;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // 清空之前的响应和错误信息
                _this3.response = null;
                _this3.error = null;
                params = {
                  page: 1,
                  size: 10,
                  brandId: bId
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/page";
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context2.sent;


                // 处理成功响应
                _this3.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response.code);
                if (_this3.response.code == 200) {
                  console.log(_this3.response.data.data);
                  // this.brandList = this.response.data.data;
                  // const item1 = {
                  //   bId: this.response.data.data,
                  // };
                  name = bId;

                  _this3.$set(_this3.shopitemlist, name, _this3.response.data.data);
                  console.log(_this3.shopitemlist[name]);
                  _this3.shopitemlist[name].forEach(function (element) {
                    element.prodContent = element.prodContent.replace(/<img[^>]*>/g, "");
                  });
                } else {}
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this3.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this3.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this3.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }
                console.log(_this3.error);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.CheckBandList();
    this.shopitemlist = {};
  },
  created: function created() {}
});

/***/ }),

/***/ "HmGK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/posbtn2.746c560.jpg";

/***/ }),

/***/ "Hpn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I5/u":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "J/AV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Myselfpage_vue__ = __webpack_require__("NEjB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddb43fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Myselfpage_vue__ = __webpack_require__("80lN");
function injectStyle (ssrContext) {
  __webpack_require__("xQRn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cddb43fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Myselfpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddb43fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Myselfpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JMHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/upimg.36480a4.png";

/***/ }),

/***/ "KTf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_block_footer__ = __webpack_require__("VIIK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Setpage',
  data: function data() {
    return {
      msg: 'setting',
      headimgurl: '',
      nickname: '',
      openid: '',
      helpshow: false,
      inveshow: false,
      myinveshow: false,
      myinves: "",
      logs: "",
      logshow: false
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_0__components_block_footer__["a" /* default */]
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;

    console.log();
    var token = localStorage.openid;
    var url = buildUrl('user/getUserInfo');
    axios.get(url, {
      params: {
        'token': token

      }
    }).then(function (response) {
      console.log(response.data.data);
      _this.myinves = response.data.data.invitationCode;
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: {
    gotoHelp: function gotoHelp() {
      this.helpshow = true;
    },
    hideHelp: function hideHelp() {
      this.helpshow = false;
    },
    gotoInve: function gotoInve() {
      this.inveshow = true;
    },
    hideInve: function hideInve() {
      var that = this;
      that.inveshow = false;
      var token = localStorage.openid;
      // this.myinves=localStorage.invitationCode;　
      // token="0d40742f4aad4d82ad041ebdb6a6a391";
      var url = buildUrl('user/invitation');
      var code = this.$refs.add_inve.value;

      axios.get(url, {
        params: {
          'token': token,
          'code': code
        }
      }).then(function (response) {
        console.log(response.data);
        that.showadd = false;
        if (response.data.code != 200) {
          that.logshow = true;
          that.logs = response.data.error;
        };
        // this.results = response.data.data;
        // console.log(this.results);
      }).catch(function (error) {
        console.log(error.error);
      });
    },
    hidelog: function hidelog() {
      this.logshow = false;
    },
    gotoMyInve: function gotoMyInve() {
      this.myinveshow = true;
    },
    hideMyinve: function hideMyinve() {
      this.myinveshow = false;
    }

  },
  created: function created() {
    // this.startGame();
  }
});

/***/ }),

/***/ "KoPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerbar"},[_c('div',{staticClass:"footbox"},[_c('div',{staticClass:"footboximg"},[_c('img',{attrs:{"src":__webpack_require__("gMGb"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"footbar"},[_c('div',{staticClass:"footerli"},[_vm._v("关于我们")])]),_vm._v(" "),_c('div',{staticClass:"footertext"},[_vm._v("\n      备案号：京ICP备2025123172号\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KtIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"homeclubbox"},[_c('div',{staticClass:"topbox"},[_c('swiper',{ref:"mySwiper",staticClass:"matchswiper",attrs:{"options":_vm.swiperOption}},[_vm._l((this.clubdes.clubImageList),function(item){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"swiperitem"},[_c('img',{attrs:{"src":item.imageUrl}})])])}),_vm._v(" "),_c('div',{staticClass:"swiper-scrollbar",attrs:{"slot":"scrollbar"},slot:"scrollbar"})],2)],1),_vm._v(" "),_c('div',{staticClass:"clubdesbox"},[_c('div',{staticClass:"destitle"},[_vm._v("俱乐部介绍")]),_vm._v(" "),_c('div',{staticClass:"descontent"},[_c('div',{staticClass:"clubnamebox"},[_c('div',{staticClass:"logoitem"},[_c('img',{attrs:{"src":_vm.clubdes.clubImage}})]),_vm._v(" "),_c('div',{staticClass:"clubname"},[_vm._v(_vm._s(_vm.clubdes.clubName))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.clubdes.introduce))])])]),_vm._v(" "),(_vm.isshowtech)?_c('div',{staticClass:"teachdesbox"},[_c('div',{staticClass:"destitle"},[_vm._v("教练团队")]),_vm._v(" "),_c('div',{staticClass:"teachbox"},[_c('swiper',{ref:"mySwiper",staticClass:"techswiper",attrs:{"options":_vm.swiperOption}},[_vm._l((this.clubdes.clubCoachList),function(item){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"teachitem"},[_c('div',{staticClass:"teachitemimg"},[_c('img',{attrs:{"src":item.imageUrl}})])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-scrollbar",attrs:{"slot":"scrollbar"},slot:"scrollbar"})],2)],1)]):_vm._e(),_vm._v(" "),(_vm.isshownews)?_c('div',{staticClass:"newsdesbox"},[_c('div',{staticClass:"destitle"},[_vm._v("俱乐部动态")]),_vm._v(" "),_vm._l((this.clubdes.clubNewsList),function(item){return _c('div',{key:item.id,staticClass:"newsitem"},[_c('div',{staticClass:"newstitle"},[_vm._v(_vm._s(item.newsTitle))]),_vm._v(" "),_c('div',{staticClass:"newsimage"},[_c('img',{attrs:{"src":item.titleImageUrl}})]),_vm._v(" "),_c('div',{staticClass:"newscontent",domProps:{"innerHTML":_vm._s(item.newsContent)}})])})],2):_vm._e()]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lg/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "racelist",
  data: function data() {
    var currentMonth = new Date().getMonth() + 1; // 获取当前月份，注意要加1，因为getMonth()返回的是0-11
    var months = [];
    var months2 = [];
    var monthIsHaveRace = [];
    var month2IsHaveRace = [];
    // 从当前月份到12月生成月份数组
    for (var i = currentMonth; i <= 12; i++) {
      months.push({ value: i, name: i + "\u6708" });
      monthIsHaveRace.push(false);
    }
    for (var _i = 1; _i <= 12; _i++) {
      months2.push({ value: _i, name: _i + "\u6708" });
      month2IsHaveRace.push(false);
    }

    return {
      showpos2: false,
      msg: "",
      months: months,
      months2: months2,
      monthIsHaveRace: monthIsHaveRace,
      month2IsHaveRace: month2IsHaveRace,
      currentMonth: currentMonth,
      currentYear: new Date().getFullYear(), // 获取当前年份
      currentYear2: new Date().getFullYear() + 1, // 获取当前年份
      raceList: []
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Home"
      });
    },
    gotoRacedes: function gotoRacedes(id) {
      // console.log(id);
      this.$router.push({
        name: "racedes",
        params: { id: id }
      });
    },

    CheckRaceList: function CheckRaceList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this.response = null;
                _this.error = null;
                params = {
                  page: 1,
                  size: 10
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfoDetails/page";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context.sent;


                // 处理成功响应
                _this.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this.response.code);
                if (_this.response.code == 200) {
                  // console.log(this.response.data);
                  _this.raceList = _this.response.data.data;

                  console.log(_this.raceList);
                  _this.raceList.forEach(function (element) {
                    var minprice = 999999;
                    element.raceContent = element.raceContent.replace(/<[^>]+>/g, "");
                    element.raceImage = "~assets/images/race/raceitem2.jpg";
                    element.imageList.forEach(function (element3) {
                      element.raceImage = element3.imageUrl;
                    });
                    element.packageList.forEach(function (element2) {
                      // console.log(element2.packageName + " " + element2.packagePrice);
                      // console.log(
                      //   element2.packagePrice +
                      //     "<" +
                      //     minprice +
                      //     "=" +
                      //     (Number(element2.packagePrice) < Number(minprice))
                      // );
                      if (Number(element2.packagePrice) < Number(minprice)) {
                        minprice = Number(element2.packagePrice);
                      }
                    });
                    element.minprice = minprice;
                    var isoDateString = element.raceDate.replace(" ", "T");
                    var dateObject = new Date(isoDateString);
                    console.log(dateObject.getMonth());
                    if (dateObject.getMonth() == 0) {
                      _this.monthIsHaveRace[12] = true;
                    } else {
                      _this.monthIsHaveRace[dateObject.getMonth() + 1] = true;
                    }
                    // console.log(element.raceName + " " + element.minprice);
                  });

                  // console.log(this.raceList);
                  // this.isShowLoginBtn = false;
                } else {
                    // this.isShowLoginBtn = true;
                  }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this.error);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.CheckRaceList();
  },
  created: function created() {}
});

/***/ }),

/***/ "MtKJ":
/***/ (function(module, exports) {

module.exports = [{"abbr":"AF","chinese":"阿富汗","code":"93","english":"Afghanistan","spell":"afuhan","state":"亚洲","french":"Afghanistan","italian":"Afghanistan","spanish":"Afganistán","japanese":"アフガニスタン","russian":"Афганистан","germen":"Afghanistan"},{"abbr":"AL","chinese":"阿尔巴尼亚","code":"355","english":"Albania","spell":"aerbaniya","state":"亚洲","french":"Albanie","italian":"Albania","spanish":"Albania","japanese":"アルバニア","russian":"Албания","germen":"Albanien"},{"abbr":"DZ","chinese":"阿尔及利亚","code":"213","english":"Algeria","spell":"aerjiliya","state":"非洲","french":"Algérie","italian":"Algeria","spanish":"Argelia","japanese":"アルジェリア","russian":"Алжир","germen":"Algerien"},{"abbr":"AO","chinese":"安哥拉","code":"244","english":"Angola","spell":"angela","state":"非洲","french":"Angola","italian":"Angola","spanish":"Angola","japanese":"アンゴラ","russian":"Ангола","germen":"Angola"},{"abbr":"AR","chinese":"阿根廷","code":"54","english":"Argentina","spell":"agenting","state":"南美洲","french":"Argentine","italian":"Argentina","spanish":"Argentina","japanese":"アルゼンチン","russian":"Аргентина","germen":"Argentinien"},{"abbr":"AM","chinese":"亚美尼亚","code":"374","english":"Armenia","spell":"yameiniya","french":"Arménie","italian":"Armenia","spanish":"Armenia","japanese":"アルメニア","russian":"Армения","germen":"Armenien"},{"abbr":"AU","chinese":"澳大利亚","code":"61","english":"Australia","spell":"aodaliya","state":"大洋洲","french":"Îles Cocos","italian":"Isole Cocos e Keeling","spanish":"Islas Cocos o Islas Keeling","japanese":"ココス（キーリング）諸島","russian":"Австралия","germen":"Kokosinseln"},{"abbr":"AT","chinese":"奥地利","code":"43","english":"Austria","spell":"aodili","state":"欧洲","french":"Autriche","italian":"Austria","spanish":"Austria","japanese":"オーストリア","russian":"Австрия","germen":"Österreich"},{"abbr":"AZ","chinese":"阿塞拜疆","code":"994","english":"Azerbaijan","spell":"asaibaijiang","state":"亚洲","french":"Azerbaïdjan","italian":"Azerbaijan","spanish":"Azerbaiyán","japanese":"アゼルバイジャン","russian":"Азербайджан","germen":"Aserbaidschan"},{"abbr":"BH","chinese":"巴林","code":"973","english":"Bahrain","spell":"balin","state":"亚洲","french":"Bahreïn","italian":"Bahrein","spanish":"Bahrein","japanese":"バーレーン","russian":"Бахрейн","germen":"Bahrain"},{"abbr":"BD","chinese":"孟加拉国","code":"880","english":"Bangladesh","spell":"mengjialaguo","state":"亚洲","french":"Bangladesh","italian":"Bangladesh","spanish":"Bangladesh","japanese":"バングラデシュ","russian":"Бангладеш","germen":"Bangladesch"},{"abbr":"BY","chinese":"白俄罗斯","code":"375","english":"Belarus","spell":"baieluosi","french":"Biélorussie","italian":"Bielorussia","spanish":"Bielorrusia","japanese":"ベラルーシ","russian":"Белоруссия","germen":"Weißrussland"},{"abbr":"BE","chinese":"比利时","code":"32","english":"Belgium","spell":"bilishi","state":"欧洲","french":"Belgique","italian":"Belgio","spanish":"Bélgica","japanese":"ベルギー","russian":"Бельгия","germen":"Belgien"},{"abbr":"BZ","chinese":"伯利兹","code":"501","english":"Belize","spell":"bolizi","french":"Belize","italian":"Belize","spanish":"Belice","japanese":"ベリーズ","russian":"Белиз","germen":"Belize"},{"abbr":"BJ","chinese":"贝宁","code":"229","english":"Benin","spell":"beining","state":"非洲","french":"Bénin","italian":"Benin","spanish":"Benín","japanese":"ベナン","russian":"Бенин","germen":"Benin"},{"abbr":"BT","chinese":"不丹","code":"975","english":"Bhutan","spell":"budan","state":"亚洲","french":"Bhoutan","italian":"Bhutan","spanish":"Bután","japanese":"ブータン","russian":"Бутан","germen":"Bhutan"},{"abbr":"BO","chinese":"玻利维亚","code":"591","english":"Bolivia","spell":"boliweiya","state":"南美洲","french":"Bolivie","italian":"Bolivia","spanish":"Bolivia","japanese":"ボリビア多民族国","russian":"Боливия","germen":"Bolivien"},{"abbr":"BA","chinese":"波斯尼亚和黑塞哥维那","code":"387","english":"Bosnia and Herzegovina","spell":"bosiniyaheheisaigeweinei","french":"Bosnie-Herzégovine","italian":"Bosnia ed Erzegovina","spanish":"Bosnia y Herzegovina","japanese":"ボスニア・ヘルツェゴビナ","russian":"Босния и Герцеговина","germen":"Bosnien und Herzegowina"},{"abbr":"BW","chinese":"博茨瓦纳","code":"267","english":"Botswana","spell":"bociwana","state":"非洲","french":"Botswana","italian":"Botswana","spanish":"Botswana","japanese":"ボツワナ","russian":"Ботсвана","germen":"Botswana"},{"abbr":"BR","chinese":"巴西","code":"55","english":"Brazil","spell":"baxi","state":"南美洲","french":"Brésil","italian":"Brasile","spanish":"Brasil","japanese":"ブラジル","russian":"Бразилия","germen":"Brasilien"},{"abbr":"VG","chinese":"英属维京群岛","code":"1284","english":"British Virgin Islands","spell":"yingshuweijingqundao","french":"Îles Vierges britanniques","italian":"Isole Vergini Britanniche","spanish":"Islas Vírgenes del Reino Unido","japanese":"イギリス領ヴァージン諸島","russian":"Британские Виргинские острова","germen":"Britische Jungferninseln"},{"abbr":"BN","chinese":"文莱","code":"673","english":"Brunei","spell":"wenlai","state":"亚洲","french":"Brunei","italian":"Brunei","spanish":"Brunei","japanese":"ブルネイ・ダルサラーム","russian":"Bulgaria","germen":"Brunei"},{"abbr":"BG","chinese":"保加利亚","code":"359","english":"Bulgaria","spell":"baojialiya","state":"欧洲","french":"Bulgarie","italian":"Bulgaria","spanish":"Bulgaria","japanese":"ブルガリア","russian":"Болгария","germen":"Bulgarien"},{"abbr":"BF","chinese":"布基纳法索","code":"226","english":"Burkina-faso","spell":"bujinafasuo","french":"Burkina Faso","italian":"Burkina Faso","spanish":"Burkina Faso","japanese":"ブルキナファソ","russian":"Буркина-Фасо","germen":"Burkina Faso"},{"abbr":"BI","chinese":"布隆迪","code":"257","english":"Burundi","spell":"bulongdi","state":"非洲","french":"Burundi","italian":"Burundi","spanish":"Burundi","japanese":"ブルンジ","russian":"Бурунди","germen":"Burundi"},{"abbr":"KH","chinese":"柬埔寨","code":"855","english":"Cambodia","spell":"jianpuzhai","state":"亚洲","french":"Cambodge","italian":"Cambogia","spanish":"Camboya","japanese":"カンボジア","russian":"Камбоджа","germen":"Kambodscha"},{"abbr":"CM","chinese":"喀麦隆","code":"237","english":"Cameroon","spell":"kamailong","state":"非洲","french":"Cameroun","italian":"Camerun","spanish":"Camerún","japanese":"カメルーン","russian":"Камерун","germen":"Kamerun"},{"abbr":"CA","chinese":"加拿大","code":"1","english":"Canada","spell":"jianada","state":"北美洲","french":"États-Unis","italian":"Stati Uniti D'America","spanish":"Estados Unidos","japanese":"アメリカ合衆国","russian":"Канада","germen":"Vereinigte Staaten von Amerika"},{"abbr":"CV","chinese":"佛得角","code":"238","english":"Cape Verde","spell":"fodejiao","state":"非洲","french":"Cap Vert","italian":"Capo Verde","spanish":"Cabo Verde","japanese":"カーボベルデ","russian":"Кабо-Верде","germen":"Kap Verde"},{"abbr":"KY","chinese":"开曼群岛","code":"1345","english":"Cayman Islands","spell":"kaimanqundao","french":"Îles Caïmans","italian":"Isole Cayman","spanish":"Islas Caimán","japanese":"ケイマン諸島","russian":"Каймановы Острова","germen":"Kaimaninseln"},{"abbr":"CF","chinese":"中非共和国","code":"236","english":"Central African Republic","spell":"zhongfeigongheguo","state":"非洲","french":"République centrafricaine","italian":"Repubblica Centrafricana","spanish":"República Centroafricana","japanese":"中央アフリカ共和国","russian":"Центрально-Африканская Республика","germen":"Zentralafrikanische Republik"},{"abbr":"TD","chinese":"乍得","code":"235","english":"Chad","spell":"zhade","french":"Tchad","italian":"Ciad","spanish":"Chad","japanese":"チャド","russian":"Чад","germen":"Tschad"},{"abbr":"CL","chinese":"智利","code":"56","english":"Chile","spell":"zhili","state":"南美洲","french":"Chili","italian":"Cile","spanish":"Chile","japanese":"チリ","russian":"Чили","germen":"Chile"},{"abbr":"CN","chinese":"中国","code":"86","english":"China","spell":"zhongguo","state":"亚洲","french":"Chine","italian":"Cina","spanish":"China","japanese":"中国","russian":"Китай","germen":"China"},{"abbr":"CO","chinese":"哥伦比亚","code":"57","english":"Colombia","spell":"gelunbiya","state":"南美洲","french":"Colombie","italian":"Colombia","spanish":"Colombia","japanese":"コロンビア","russian":"Колумбия","germen":"Kolumbien"},{"abbr":"KM","chinese":"科摩罗","code":"269","english":"Comoros","spell":"kemoluo","french":"Comores","italian":"Comore","spanish":"Comoras","japanese":"コモロ","russian":"Коморские острова","germen":"Union der Komoren"},{"abbr":"CG","chinese":"刚果(布)","code":"242","english":"Congo - Brazzaville","spell":"gangguo(bu)","state":"非洲","french":"Congo","italian":"Congo","spanish":"Congo","japanese":"コンゴ共和国","russian":"Конго - Браззавиль","germen":"Kongo"},{"abbr":"CD","chinese":"刚果(金)","code":"243","english":"Congo - Kinshasa","spell":"gangguo(jin)","french":"Congo (Rép. dém.)","italian":"Congo (Rep. Dem.)","spanish":"Congo (Rep. Dem.)","japanese":"コンゴ民主共和国","russian":"Конго - Киншаса","germen":"Kongo (Dem. Rep.)"},{"abbr":"CR","chinese":"哥斯达黎加","code":"506","english":"Costa Rica","spell":"gesidalijia","state":"北美洲","french":"Costa Rica","italian":"Costa Rica","spanish":"Costa Rica","japanese":"コスタリカ","russian":"Коста-Рика","germen":"Costa Rica"},{"abbr":"HR","chinese":"克罗地亚","code":"385","english":"Croatia","spell":"keluodiya","state":"欧洲","french":"Croatie","italian":"Croazia","spanish":"Croacia","japanese":"クロアチア","russian":"Хорватия","germen":"Kroatien"},{"abbr":"CY","chinese":"塞浦路斯","code":"357","english":"Cyprus","spell":"saipulusi","state":"亚洲","french":"Chypre","italian":"Cipro","spanish":"Chipre","japanese":"キプロス","russian":"Кипр","germen":"Zypern"},{"abbr":"CZ","chinese":"捷克共和国","code":"420","english":"Czech Republic","spell":"jiekegongheguo","state":"欧洲","french":"République tchèque","italian":"Repubblica Ceca","spanish":"República Checa","japanese":"チェコ","russian":"Чехия","germen":"Tschechische Republik"},{"abbr":"DK","chinese":"丹麦","code":"45","english":"Denmark","spell":"danmai","state":"欧洲","french":"Danemark","italian":"Danimarca","spanish":"Dinamarca","japanese":"デンマーク","russian":"Дания","germen":"Dänemark"},{"abbr":"DJ","chinese":"吉布提","code":"253","english":"Djibouti","spell":"jibuti","french":"Djibouti","italian":"Gibuti","spanish":"Yibuti","japanese":"ジブチ","russian":"Джибути","germen":"Dschibuti"},{"abbr":"DO","chinese":"多米尼加共和国","code":"1809","english":"Dominican Republic","spell":"duominijiagongheguo","french":"République dominicaine","italian":"Repubblica Dominicana","spanish":"República Dominicana","japanese":"ドミニカ共和国","russian":"Доминиканская Республика","germen":"Dominikanische Republik"},{"abbr":"EC","chinese":"厄瓜多尔","code":"593","english":"Ecuador","spell":"eguaduoer","state":"南美洲","french":"Équateur","italian":"Ecuador","spanish":"Ecuador","japanese":"エクアドル","russian":"Эквадор","germen":"Ecuador"},{"abbr":"EG","chinese":"埃及","code":"20","english":"Egypt","spell":"aiji","state":"非洲","french":"Égypte","italian":"Egitto","spanish":"Egipto","japanese":"エジプト","russian":"Египет","germen":"Ägypten"},{"abbr":"SV","chinese":"萨尔瓦多","code":"503","english":"EI Salvador","spell":"saerwaduo","french":"Salvador","italian":"El Salvador","spanish":"El Salvador","japanese":"エルサルバドル","russian":"EI Сальвадор","germen":"El Salvador"},{"abbr":"GQ","chinese":"赤道几内亚","code":"240","english":"Equatorial Guinea","spell":"chidaojineiya","state":"非洲","french":"Guinée-Équatoriale","italian":"Guinea Equatoriale","spanish":"Guinea Ecuatorial","japanese":"赤道ギニア","russian":"Экваториальная Гвинея","germen":"Äquatorial-Guinea"},{"abbr":"ER","chinese":"厄立特里亚","code":"291","english":"Eritrea","spell":"eliteliya","french":"Érythrée","italian":"Eritrea","spanish":"Eritrea","japanese":"エリトリア","russian":"Эритрея","germen":"Eritrea"},{"abbr":"EE","chinese":"爱沙尼亚","code":"372","english":"Estonia","spell":"aishaniya","state":"欧洲","french":"Estonie","italian":"Estonia","spanish":"Estonia","japanese":"エストニア","russian":"Эстония","germen":"Estland"},{"abbr":"ET","chinese":"埃塞俄比亚","code":"251","english":"Ethiopia","spell":"aisaiebiya","state":"非洲","french":"Éthiopie","italian":"Etiopia","spanish":"Etiopía","japanese":"エチオピア","russian":"Эфиопия","germen":"Äthiopien"},{"abbr":"FJ","chinese":"斐济","code":"679","english":"Fiji","spell":"feiji","state":"大洋洲","french":"Fidji","italian":"Figi","spanish":"Fiyi","japanese":"フィジー","russian":"Фиджи","germen":"Fidschi"},{"abbr":"FI","chinese":"芬兰","code":"358","english":"Finland","spell":"fenlan","state":"欧洲","french":"Finlande","italian":"Finlandia","spanish":"Finlandia","japanese":"フィンランド","russian":"Финляндия","germen":"Finnland"},{"abbr":"FR","chinese":"法国","code":"33","english":"France","spell":"faguo","state":"欧洲","french":"France","italian":"Francia","spanish":"Francia","japanese":"フランス","russian":"Франция","germen":"Frankreich"},{"abbr":"GA","chinese":"加蓬","code":"241","english":"Gabon","spell":"jiapeng","state":"非洲","french":"Gabon","italian":"Gabon","spanish":"Gabón","japanese":"ガボン","russian":"Габон","germen":"Gabun"},{"abbr":"GM","chinese":"冈比亚","code":"220","english":"Gambia","spell":"gangbiya","state":"非洲","french":"Gambie","italian":"Gambia","spanish":"Gambia","japanese":"ガンビア","russian":"Гамбия","germen":"Gambia"},{"abbr":"GE","chinese":"格鲁吉亚","code":"995","english":"Georgia","spell":"gelujiya","french":"Géorgie","italian":"Georgia","spanish":"Georgia","japanese":"グルジア","russian":"Грузия","germen":"Georgien"},{"abbr":"DE","chinese":"德国","code":"49","english":"Germany","spell":"deguo","state":"欧洲","french":"Allemagne","italian":"Germania","spanish":"Alemania","japanese":"ドイツ","russian":"Германия","germen":"Deutschland"},{"abbr":"GH","chinese":"加纳","code":"233","english":"Ghana","spell":"jiana","state":"非洲","french":"Ghana","italian":"Ghana","spanish":"Ghana","japanese":"ガーナ","russian":"Гана","germen":"Ghana"},{"abbr":"GR","chinese":"希腊","code":"30","english":"Greece","spell":"xila","state":"欧洲","french":"Grèce","italian":"Grecia","spanish":"Grecia","japanese":"ギリシャ","russian":"Греция","germen":"Griechenland"},{"abbr":"GL","chinese":"格陵兰","code":"299","english":"Greenland","spell":"gelinglan","french":"Groenland","italian":"Groenlandia","spanish":"Groenlandia","japanese":"グリーンランド","russian":"Гренландия","germen":"Grönland"},{"abbr":"GT","chinese":"危地马拉","code":"502","english":"Guatemala","spell":"weidimala","state":"北美洲","french":"Guatemala","italian":"Guatemala","spanish":"Guatemala","japanese":"グアテマラ","russian":"Гватемала","germen":"Guatemala"},{"abbr":"GN","chinese":"几内亚","code":"224","english":"Guinea","spell":"jineiya","state":"非洲","french":"Guinée","italian":"Guinea","spanish":"Guinea","japanese":"ギニア","russian":"Гвинея","germen":"Guinea"},{"abbr":"GY","chinese":"圭亚那","code":"592","english":"Guyana","spell":"guiyanei","state":"南美洲","french":"Guyane","italian":"Guyana","spanish":"Guyana","japanese":"ガイアナ","russian":"Гайана","germen":"Guyana"},{"abbr":"HT","chinese":"海地","code":"509","english":"Haiti","spell":"haidi","state":"北美洲","french":"Haïti","italian":"Haiti","spanish":"Haiti","japanese":"ハイチ","russian":"Гаити","germen":"Haiti"},{"abbr":"HN","chinese":"洪都拉斯","code":"504","english":"Honduras","spell":"hongdoulasi","state":"北美洲","french":"Honduras","italian":"Honduras","spanish":"Honduras","japanese":"ホンジュラス","russian":"Гондурас","germen":"Honduras"},{"abbr":"HK","chinese":"中国香港特别行政区","code":"852","english":"Hongkong SAR China","spell":"zhongguoxianggangtebiexingzhengqu","state":"亚洲","french":"Hong Kong","italian":"Hong Kong","spanish":"Hong Kong","japanese":"香港","russian":"Гонконг SAR Китай","germen":"Hong Kong"},{"abbr":"HU","chinese":"匈牙利","code":"36","english":"Hungary","spell":"xiongyali","state":"欧洲","french":"Hongrie","italian":"Ungheria","spanish":"Hungría","japanese":"ハンガリー","russian":"Венгрия","germen":"Ungarn"},{"abbr":"IS","chinese":"冰岛","code":"354","english":"Iceland","spell":"bingdao","state":"欧洲","french":"Islande","italian":"Islanda","spanish":"Islandia","japanese":"アイスランド","russian":"Исландия","germen":"Island"},{"abbr":"IN","chinese":"印度","code":"91","english":"India","spell":"yindu","state":"亚洲","french":"Inde","italian":"India","spanish":"India","japanese":"インド","russian":"Индия","germen":"Indien"},{"abbr":"ID","chinese":"印度尼西亚","code":"62","english":"Indonesia","spell":"yindunixiya","state":"亚洲","french":"Indonésie","italian":"Indonesia","spanish":"Indonesia","japanese":"インドネシア","russian":"Индонезия","germen":"Indonesien"},{"abbr":"IR","chinese":"伊朗","code":"98","english":"Iran","spell":"yilang","state":"亚洲","french":"Iran","italian":"Iran","spanish":"Iran","japanese":"イラン・イスラム共和国","russian":"Иран","germen":"Iran"},{"abbr":"IQ","chinese":"伊拉克","code":"964","english":"Iraq","spell":"yilake","state":"亚洲","french":"Irak","italian":"Iraq","spanish":"Irak","japanese":"イラク","russian":"Ирак","germen":"Irak"},{"abbr":"IE","chinese":"爱尔兰","code":"353","english":"Ireland","spell":"aierlan","state":"欧洲","french":"Irlande","italian":"Irlanda","spanish":"Irlanda","japanese":"アイルランド","russian":"Ирландия","germen":"Irland"},{"abbr":"IM","chinese":"马恩岛","code":"44","english":"Isle of Man","spell":"maendao","french":"Royaume-Uni","italian":"Regno Unito","spanish":"Reino Unido","japanese":"イギリス","russian":"Остров Мэн","germen":"Vereinigtes Königreich"},{"abbr":"IL","chinese":"以色列","code":"972","english":"Israel","spell":"yiselie","state":"亚洲","french":"Israël","italian":"Israele","spanish":"Israel","japanese":"イスラエル","russian":"Израиль","germen":"Israel"},{"abbr":"IT","chinese":"意大利","code":"39","english":"Italy","spell":"yidali","state":"欧洲","french":"Italie","italian":"Italia","spanish":"Italia","japanese":"イタリア","russian":"Италия","germen":"Italien"},{"abbr":"CI","chinese":"科特迪瓦","code":"225","english":"Ivory Coast","spell":"ketediwa","french":"Côte d'Ivoire","italian":"Costa D'Avorio","spanish":"Costa de Marfil","japanese":"コートジボワール","russian":"Кот-д'Ивуар","germen":"Elfenbeinküste"},{"abbr":"JM","chinese":"牙买加","code":"1876","english":"Jamaica","spell":"yamaijia","state":"北美洲","french":"Jamaïque","italian":"Giamaica","spanish":"Jamaica","japanese":"ジャマイカ","russian":"Ямайка","germen":"Jamaika"},{"abbr":"JP","chinese":"日本","code":"81","english":"Japan","spell":"riben","state":"亚洲","french":"Japon","italian":"Giappone","spanish":"Japón","japanese":"日本","russian":"Япония","germen":"Japan"},{"abbr":"JO","chinese":"约旦","code":"962","english":"Jordan","spell":"yuedan","state":"亚洲","french":"Jordanie","italian":"Giordania","spanish":"Jordania","japanese":"ヨルダン","russian":"Иордания","germen":"Jordanien"},{"abbr":"KZ","chinese":"哈萨克斯坦","code":"7","english":"Kazakstan","spell":"hasakesitan","state":"亚洲","french":"Russie","italian":"Russia","spanish":"Rusia","japanese":"ロシア連邦","russian":"Казахстан","germen":"Russland"},{"abbr":"KE","chinese":"肯尼亚","code":"254","english":"Kenya","spell":"kenniya","state":"非洲","french":"Kenya","italian":"Kenya","spanish":"Kenia","japanese":"ケニア","russian":"Кения","germen":"Kenia"},{"abbr":"KR","chinese":"韩国","code":"82","english":"Korea","spell":"hanguo","state":"亚洲","french":"Corée du Sud","italian":"Corea del Sud","spanish":"Corea del Sur","japanese":"大韓民国","russian":"Корея","germen":"Südkorea"},{"abbr":"KW","chinese":"科威特","code":"965","english":"Kuwait","spell":"keweite","state":"亚洲","french":"Koweït","italian":"Kuwait","spanish":"Kuwait","japanese":"クウェート","russian":"Кувейт","germen":"Kuwait"},{"abbr":"KG","chinese":"吉尔吉斯斯坦","code":"996","english":"Kyrgyzstan","spell":"jierjisisitan","french":"Kirghizistan","italian":"Kirghizistan","spanish":"Kirguizistán","japanese":"キルギス","russian":"Киргизия","germen":"Kirgisistan"},{"abbr":"LA","chinese":"老挝","code":"856","english":"Laos","spell":"laowo","state":"亚洲","french":"Laos","italian":"Laos","spanish":"Laos","japanese":"ラオス人民民主共和国","russian":"Лаос","germen":"Laos"},{"abbr":"LV","chinese":"拉脱维亚","code":"371","english":"Latvia","spell":"latuoweiya","state":"欧洲","french":"Lettonie","italian":"Lettonia","spanish":"Letonia","japanese":"ラトビア","russian":"Латвия","germen":"Lettland"},{"abbr":"LB","chinese":"黎巴嫩","code":"961","english":"Lebanon","spell":"libanen","state":"亚洲","french":"Liban","italian":"Libano","spanish":"Líbano","japanese":"レバノン","russian":"Ливан","germen":"Libanon"},{"abbr":"LS","chinese":"莱索托","code":"266","english":"Lesotho","spell":"laisuotuo","french":"Lesotho","italian":"Lesotho","spanish":"Lesotho","japanese":"レソト","russian":"Лесото","germen":"Lesotho"},{"abbr":"LR","chinese":"利比里亚","code":"231","english":"Liberia","spell":"libiliya","french":"Liberia","italian":"Liberia","spanish":"Liberia","japanese":"リベリア","russian":"Либерия","germen":"Liberia"},{"abbr":"LY","chinese":"利比亚","code":"218","english":"Libya","spell":"libiya","state":"非洲","french":"Libye","italian":"Libia","spanish":"Libia","japanese":"リビア","russian":"Ливия","germen":"Libyen"},{"abbr":"LT","chinese":"立陶宛","code":"370","english":"Lithuania","spell":"litaowan","state":"欧洲","french":"Lituanie","italian":"Lituania","spanish":"Lituania","japanese":"リトアニア","russian":"Литва","germen":"Litauen"},{"abbr":"LU","chinese":"卢森堡","code":"352","english":"Luxembourg","spell":"lusenbao","state":"亚洲","french":"Luxembourg","italian":"Lussemburgo","spanish":"Luxemburgo","japanese":"ルクセンブルク","russian":"Люксембург","germen":"Luxemburg"},{"abbr":"MO","chinese":"中国澳门特别行政区","code":"853","english":"Macao SAR China","spell":"zhongguoaomentebiexingzhengqu","state":"亚洲","french":"Macao","italian":"Macao","spanish":"Macao","japanese":"マカオ","russian":"Макао SAR Китай","germen":"Macao"},{"abbr":"MK","chinese":"马其顿","code":"389","english":"Macedonia","spell":"maqidun","french":"Macédoine","italian":"Macedonia","spanish":"Macedonia","japanese":"マケドニア旧ユーゴスラビア共和国","russian":"Македония","germen":"Mazedonien"},{"abbr":"MG","chinese":"马达加斯加","code":"261","english":"Madagascar","spell":"madajiasijia","state":"非洲","french":"Madagascar","italian":"Madagascar","spanish":"Madagascar","japanese":"マダガスカル","russian":"Мадагаскар","germen":"Madagaskar"},{"abbr":"MW","chinese":"马拉维","code":"265","english":"Malawi","spell":"malawei","french":"Malawi","italian":"Malawi","spanish":"Malawi","japanese":"マラウイ","russian":"Малави","germen":"Malawi"},{"abbr":"MY","chinese":"马来西亚","code":"60","english":"Malaysia","spell":"malaixiya","state":"亚洲","french":"Malaisie","italian":"Malesia","spanish":"Malasia","japanese":"マレーシア","russian":"Малайзия","germen":"Malaysia"},{"abbr":"MV","chinese":"马尔代夫","code":"960","english":"Maldives","spell":"maerdaifu","state":"亚洲","french":"Maldives","italian":"Maldive","spanish":"Maldivas","japanese":"モルディブ","russian":"Мальдивы","germen":"Malediven"},{"abbr":"ML","chinese":"马里","code":"223","english":"Mali","spell":"mali","state":"非洲","french":"Mali","italian":"Mali","spanish":"Mali","japanese":"マリ","russian":"Мали","germen":"Mali"},{"abbr":"MT","chinese":"马耳他","code":"356","english":"Malta","spell":"maerta","state":"欧洲","french":"Malte","italian":"Malta","spanish":"Malta","japanese":"マルタ","russian":"Мальта","germen":"Malta"},{"abbr":"MR","chinese":"毛利塔尼亚","code":"222","english":"Mauritania","spell":"maolitaniya","state":"非洲","french":"Mauritanie","italian":"Mauritania","spanish":"Mauritania","japanese":"モーリタニア","russian":"Мавритания","germen":"Mauretanien"},{"abbr":"MU","chinese":"毛里求斯","code":"230","english":"Mauritius","spell":"maoliqiusi","state":"非洲","french":"Île Maurice","italian":"Mauritius","spanish":"Mauricio","japanese":"モーリシャス","russian":"Маврикий","germen":"Mauritius"},{"abbr":"MX","chinese":"墨西哥","code":"52","english":"Mexico","spell":"moxige","state":"北美洲","french":"Mexique","italian":"Messico","spanish":"México","japanese":"メキシコ","russian":"Мексика","germen":"Mexiko"},{"abbr":"MD","chinese":"摩尔多瓦","code":"373","english":"Moldova","spell":"moerduowa","state":"欧洲","french":"Moldavie","italian":"Moldavia","spanish":"Moldavia","japanese":"モルドバ共和国","russian":"Молдавия","germen":"Moldawie"},{"abbr":"MC","chinese":"摩纳哥","code":"377","english":"Monaco","spell":"monage","state":"欧洲","french":"Monaco","italian":"Principato di Monaco","spanish":"Mónaco","japanese":"モナコ","russian":"Монако","germen":"Monaco"},{"abbr":"MN","chinese":"蒙古","code":"976","english":"Mongolia","spell":"menggu","state":"亚洲","french":"Mongolie","italian":"Mongolia","spanish":"Mongolia","japanese":"モンゴル","russian":"Монголия","germen":"Mongolei"},{"abbr":"ME","chinese":"黑山共和国","code":"382","english":"Montenegro","spell":"heishangongheguo","french":"Monténégro","italian":"Montenegro","spanish":"Montenegro","japanese":"モンテネグロ","russian":"Черногория","germen":"Montenegro"},{"abbr":"MA","chinese":"摩洛哥","code":"212","english":"Morocco","spell":"moluoge","state":"非洲","french":"Sahara Occidental","italian":"Sahara Occidentale","spanish":"Sahara Occidental","japanese":"西サハラ","russian":"Марокко","germen":"Westsahara"},{"abbr":"MZ","chinese":"莫桑比克","code":"258","english":"Mozambique","spell":"mosangbike","state":"非洲","french":"Mozambique","italian":"Mozambico","spanish":"Mozambique","japanese":"モザンビーク","russian":"Мозамбик","germen":"Mosambik"},{"abbr":"MM","chinese":"缅甸","code":"95","english":"Myanmar(Burma)","spell":"miandian","french":"Myanmar","italian":"Birmania","spanish":"Myanmar","japanese":"ミャンマー","russian":"Мьянма (Бирма)","germen":"Myanmar"},{"abbr":"NA","chinese":"纳米比亚","code":"264","english":"Namibia","spell":"namibiya","state":"非洲","french":"Namibie","italian":"Namibia","spanish":"Namibia","japanese":"ナミビア","russian":"Намибия","germen":"Namibia"},{"abbr":"NP","chinese":"尼泊尔","code":"977","english":"Nepal","spell":"niboer","state":"亚洲","french":"Népal","italian":"Nepal","spanish":"Nepal","japanese":"ネパール","russian":"Непал","germen":"Népal"},{"abbr":"NL","chinese":"荷兰","code":"31","english":"Netherlands","spell":"helan","state":"欧洲","french":"Pays-Bas","italian":"Paesi Bassi","spanish":"Países Bajos","japanese":"オランダ","russian":"Нидерланды","germen":"Niederlande"},{"abbr":"NZ","chinese":"新西兰","code":"64","english":"New Zealand","spell":"xinxilan","state":"大洋洲","french":"Îles Pitcairn","italian":"Isole Pitcairn","spanish":"Islas Pitcairn","japanese":"ピトケアン","russian":"Новая Зеландия","germen":"Pitcairn"},{"abbr":"NI","chinese":"尼加拉瓜","code":"505","english":"Nicaragua","spell":"nijialagua","state":"北美洲","french":"Nicaragua","italian":"Nicaragua","spanish":"Nicaragua","japanese":"ニカラグア","russian":"Никарагуа","germen":"Nicaragua"},{"abbr":"NE","chinese":"尼日尔","code":"227","english":"Niger","spell":"nirier","state":"非洲","french":"Niger","italian":"Niger","spanish":"Níger","japanese":"ニジェール","russian":"Нигер","germen":"Niger"},{"abbr":"NG","chinese":"尼日利亚","code":"234","english":"Nigeria","spell":"niriliya","state":"非洲","french":"Nigéria","italian":"Nigeria","spanish":"Nigeria","japanese":"ナイジェリア","russian":"Нигерия","germen":"Nigeria"},{"abbr":"KP","chinese":"朝鲜","code":"850","english":"North Korea","spell":"chaoxian","state":"亚洲","french":"Corée du Nord","italian":"Corea del Nord","spanish":"Corea del Norte","japanese":"朝鮮民主主義人民共和国","russian":"Северная Корея","germen":"Nordkorea"},{"abbr":"NO","chinese":"挪威","code":"47","english":"Norway","spell":"nuowei","state":"欧洲","french":"Norvège","italian":"Norvegia","spanish":"Noruega","japanese":"ノルウェー","russian":"Норвегия","germen":"Norwegen"},{"abbr":"OM","chinese":"阿曼","code":"968","english":"Oman","spell":"aman","state":"亚洲","french":"Oman","italian":"oman","spanish":"Omán","japanese":"オマーン","russian":"Оман","germen":"Oman"},{"abbr":"PK","chinese":"巴基斯坦","code":"92","english":"Pakistan","spell":"bajisitan","state":"亚洲","french":"Pakistan","italian":"Pakistan","spanish":"Pakistán","japanese":"パキスタン","russian":"Пакистан","germen":"Pakistan"},{"abbr":"PA","chinese":"巴拿马","code":"507","english":"Panama","spell":"banama","state":"北美洲","french":"Panama","italian":"Panama","spanish":"Panamá","japanese":"パナマ","russian":"Панама","germen":"Panama"},{"abbr":"PY","chinese":"巴拉圭","code":"595","english":"Paraguay","spell":"balagui","state":"南美洲","french":"Paraguay","italian":"Paraguay","spanish":"Paraguay","japanese":"パラグアイ","russian":"Парагвай","germen":"Paraguay"},{"abbr":"PE","chinese":"秘鲁","code":"51","english":"Peru","spell":"milu","state":"南美洲","french":"Pérou","italian":"Perù","spanish":"Perú","japanese":"ペルー","russian":"Перу","germen":"Peru"},{"abbr":"PH","chinese":"菲律宾","code":"63","english":"Philippines","spell":"feilvbin","state":"亚洲","french":"Philippines","italian":"Filippine","spanish":"Filipinas","japanese":"フィリピン","russian":"Филиппины","germen":"Philippinen"},{"abbr":"PL","chinese":"波兰","code":"48","english":"Poland","spell":"bolan","state":"欧洲","french":"Pologne","italian":"Polonia","spanish":"Polonia","japanese":"ポーランド","russian":"Польша","germen":"Polen"},{"abbr":"PT","chinese":"葡萄牙","code":"351","english":"Portugal","spell":"putaoya","state":"欧洲","french":"Portugal","italian":"Portogallo","spanish":"Portugal","japanese":"ポルトガル","russian":"Португалия","germen":"Portugal"},{"abbr":"PR","chinese":"波多黎各","code":"1787","english":"Puerto Rico","spell":"boduolige","french":"Porto Rico","italian":"Porto Rico","spanish":"Puerto Rico","japanese":"プエルトリコ","russian":"Пуэрто-Рико","germen":"Puerto Rico"},{"abbr":"QA","chinese":"卡塔尔","code":"974","english":"Qatar","spell":"kataer","state":"亚洲","french":"Qatar","italian":"Qatar","spanish":"Catar","japanese":"カタール","russian":"Катар","germen":"Katar"},{"abbr":"RE","chinese":"留尼旺","code":"262","english":"Reunion","spell":"liuniwang","french":"Réunion","italian":"Riunione","spanish":"Reunión","japanese":"レユニオン","russian":"воссоединение","germen":"Réunion"},{"abbr":"RO","chinese":"罗马尼亚","code":"40","english":"Romania","spell":"luomaniya","state":"欧洲","french":"Roumanie","italian":"Romania","spanish":"Rumania","japanese":"ルーマニア","russian":"Румыния","germen":"Rumänien"},{"abbr":"RU","chinese":"俄罗斯","code":"7","english":"Russia","spell":"eluosi","state":"欧洲","french":"Russie","italian":"Russia","spanish":"Rusia","japanese":"ロシア連邦","russian":"Россия","germen":"Russland"},{"abbr":"RW","chinese":"卢旺达","code":"250","english":"Rwanda","spell":"luwangda","state":"非洲","french":"Rwanda","italian":"Ruanda","spanish":"Ruanda","japanese":"ルワンダ","russian":"Руанда","germen":"Ruanda"},{"abbr":"SM","chinese":"圣马力诺","code":"378","english":"San Marino","spell":"shengmalinuo","state":"欧洲","french":"Saint-Marin","italian":"San Marino","spanish":"San Marino","japanese":"サンマリノ","russian":"Сан-Марино","germen":"San Marino"},{"abbr":"SA","chinese":"沙特阿拉伯","code":"966","english":"Saudi Arabia","spell":"shatealabo","state":"亚洲","french":"Arabie Saoudite","italian":"Arabia Saudita","spanish":"Arabia Saudí","japanese":"サウジアラビア","russian":"Саудовская Аравия","germen":"Saudi-Arabien"},{"abbr":"SN","chinese":"塞内加尔","code":"221","english":"Senegal","spell":"saineijiaer","state":"非洲","french":"Sénégal","italian":"Senegal","spanish":"Senegal","japanese":"セネガル","russian":"Сенегал","germen":"Senegal"},{"abbr":"RS","chinese":"塞尔维亚","code":"381","english":"Serbia","spell":"saierweiya","french":"Serbie","italian":"Serbia","spanish":"Serbia","japanese":"セルビア","russian":"Сербия","germen":"Serbien"},{"abbr":"SL","chinese":"塞拉利昂","code":"232","english":"Sierra Leone","spell":"sailaliang","french":"Sierra Leone","italian":"Sierra Leone","spanish":"Sierra Leone","japanese":"シエラレオネ","russian":"Сьерра-Леоне","germen":"Sierra Leone"},{"abbr":"SG","chinese":"新加坡","code":"65","english":"Singapore","spell":"xinjiapo","state":"亚洲","french":"Singapour","italian":"Singapore","spanish":"Singapur","japanese":"シンガポール","russian":"Сингапур","germen":"Singapur"},{"abbr":"SK","chinese":"斯洛伐克","code":"421","english":"Slovakia","spell":"siluofake","state":"欧洲","french":"Slovaquie","italian":"Slovacchia","spanish":"República Eslovaca","japanese":"スロバキア","russian":"Словакия","germen":"Slowakei"},{"abbr":"SI","chinese":"斯洛文尼亚","code":"386","english":"Slovenia","spell":"siluowenniya","french":"Slovénie","italian":"Slovenia","spanish":"Eslovenia","japanese":"スロベニア","russian":"Словения","germen":"Slowenien"},{"abbr":"SO","chinese":"索马里","code":"252","english":"Somalia","spell":"suomali","state":"非洲","french":"Somalie","italian":"Somalia","spanish":"Somalia","japanese":"ソマリア","russian":"Сомали","germen":"Somalia"},{"abbr":"ZA","chinese":"南非","code":"27","english":"South Africa","spell":"nanfei","state":"非洲","french":"Afrique du Sud","italian":"Sud Africa","spanish":"República de Sudáfrica","japanese":"南アフリカ","russian":"Южно-Африканская Республика (ЮАР)","germen":"Republik Südafrika"},{"abbr":"ES","chinese":"西班牙","code":"34","english":"Spain","spell":"xibanya","state":"欧洲","french":"Espagne","italian":"Spagna","spanish":"España","japanese":"スペイン","russian":"Испания","germen":"Spanien"},{"abbr":"LK","chinese":"斯里兰卡","code":"94","english":"Sri Lanka","spell":"sililanka","french":"Sri Lanka","italian":"Sri Lanka","spanish":"Sri Lanka","japanese":"スリランカ","russian":"Шри-Ланка","germen":"Sri Lanka"},{"abbr":"SD","chinese":"苏丹","code":"249","english":"Sudan","spell":"sudan","state":"非洲","french":"Soudan","italian":"Sudan","spanish":"Sudán","japanese":"スーダン","russian":"Судан","germen":"Sudan"},{"abbr":"SR","chinese":"苏里南","code":"597","english":"Suriname","spell":"sulinan","french":"Surinam","italian":"Suriname","spanish":"Surinam","japanese":"スリナム","russian":"Суринам","germen":"Suriname"},{"abbr":"SZ","chinese":"斯威士兰","code":"268","english":"Swaziland","spell":"siweishilan","french":"Swaziland","italian":"Swaziland","spanish":"Suazilandia","japanese":"スワジランド","russian":"Свазиленд","germen":"Swasiland"},{"abbr":"SE","chinese":"瑞典","code":"46","english":"Sweden","spell":"ruidian","state":"欧洲","french":"Suède","italian":"Svezia","spanish":"Suecia","japanese":"スウェーデン","russian":"Швеция","germen":"Schweden"},{"abbr":"CH","chinese":"瑞士","code":"41","english":"Switzerland","spell":"ruishi","state":"欧洲","french":"Suisse","italian":"Svizzera","spanish":"Suiza","japanese":"スイス","russian":"Швейцария","germen":"Schweiz"},{"abbr":"SY","chinese":"叙利亚","code":"963","english":"Syria","spell":"xuliya","state":"亚洲","french":"Syrie","italian":"Siria","spanish":"Siria","japanese":"シリア・アラブ共和国","russian":"Сирия","germen":"Syrien"},{"abbr":"TW","chinese":"中国台湾","code":"886","english":"China Taiwan","spell":"zhongguotaiwan","state":"亚洲","french":"Taïwan","italian":"Taiwan","spanish":"Taiwán","japanese":"台湾（中国）","russian":"Тайвань","germen":"Taiwan"},{"abbr":"TJ","chinese":"塔吉克斯坦","code":"992","english":"Tajikstan","spell":"tajikesitan","state":"亚洲","french":"Tadjikistan","italian":"Tagikistan","spanish":"Tayikistán","japanese":"タジキスタン","russian":"Таджикистан","germen":"Tadschikistan"},{"abbr":"TZ","chinese":"坦桑尼亚","code":"255","english":"Tanzania","spell":"tansangniya","state":"非洲","french":"Tanzanie","italian":"Tanzania","spanish":"Tanzania","japanese":"タンザニア","russian":"Танзания","germen":"Tansania"},{"abbr":"TH","chinese":"泰国","code":"66","english":"Thailand","spell":"taiguo","state":"亚洲","french":"Thaïlande","italian":"Tailandia","spanish":"Tailandia","japanese":"タイ","russian":"Таиланд","germen":"Thailand"},{"abbr":"TG","chinese":"多哥","code":"228","english":"Togo","spell":"duoge","french":"Togo","italian":"Togo","spanish":"Togo","japanese":"トーゴ","russian":"Того","germen":"Togo"},{"abbr":"TO","chinese":"汤加","code":"676","english":"Tonga","spell":"tangjia","state":"大洋洲","french":"Tonga","italian":"Tonga","spanish":"Tonga","japanese":"トンガ","russian":"Тонга","germen":"Tonga"},{"abbr":"TT","chinese":"特立尼达和多巴哥","code":"1868","english":"Trinidad and Tobago","spell":"telinidaheduobage","french":"Trinité et Tobago","italian":"Trinidad e Tobago","spanish":"Trinidad y Tobago","japanese":"トリニダード・トバゴ","russian":"Тринидад и Тобаго","germen":"Trinidad und Tobago"},{"abbr":"TN","chinese":"突尼斯","code":"216","english":"Tunisia","spell":"tunisi","state":"非洲","french":"Tunisie","italian":"Tunisia","spanish":"Túnez","japanese":"チュニジア","russian":"Тунис","germen":"Tunesien"},{"abbr":"TR","chinese":"土耳其","code":"90","english":"Turkey","spell":"tuerqi","french":"Turquie","italian":"Turchia","spanish":"Turquía","japanese":"トルコ","russian":"Турция","germen":"Türkei"},{"abbr":"TM","chinese":"土库曼斯坦","code":"993","english":"Turkmenistan","spell":"tukumansitan","state":"亚洲","french":"Turkménistan","italian":"Turkmenistan","spanish":"Turkmenistán","japanese":"トルクメニスタン","russian":"Туркменистан","germen":"Turkmenistan"},{"abbr":"VI","chinese":"美属维尔京群岛","code":"1340","english":"U.S. Virgin Islands","spell":"meishuweierjingqundao","french":"Îles Vierges américaines","italian":"Isole Vergini americane","spanish":"Islas Vírgenes de EE.UU","japanese":"米領バージン諸島","russian":"Виргинские острова США","germen":"US Jungferninseln"},{"abbr":"UG","chinese":"乌干达","code":"256","english":"Uganda","spell":"wuganda","state":"非洲","french":"Uganda","italian":"Uganda","spanish":"Uganda","japanese":"ウガンダ","russian":"Уганда","germen":"Uganda"},{"abbr":"UA","chinese":"乌克兰","code":"380","english":"Ukraine","spell":"wukelan","state":"欧洲","french":"Ukraine","italian":"Ucraina","spanish":"Ucrania","japanese":"ウクライナ","russian":"Украина","germen":"Ukraine"},{"abbr":"AE","chinese":"阿拉伯联合酋长国","code":"971","english":"United Arab Emirates","spell":"alabolianheqiuzhangguo","state":"亚洲","french":"Émirats arabes unis","italian":"Emirati Arabi Uniti","spanish":"Emiratos Árabes Unidos","japanese":"アラブ首長国連邦","russian":"Объединённые Арабские Эмираты (ОАЭ)","germen":"Vereinigte Arabische Emirate"},{"abbr":"GB","chinese":"英国","code":"44","english":"United Kiongdom","spell":"yingguo","state":"欧洲","french":"Royaume-Uni","italian":"Regno Unito","spanish":"Reino Unido","japanese":"イギリス","russian":"Объединенное Королевство","germen":"Vereinigtes Königreich"},{"abbr":"US","chinese":"美国","code":"1","english":"USA","spell":"meiguo","state":"北美洲","french":"États-Unis","italian":"Stati Uniti D'America","spanish":"Estados Unidos","japanese":"アメリカ合衆国","russian":"Соединенные Штаты Америки","germen":"Vereinigte Staaten von Amerika"},{"abbr":"UY","chinese":"乌拉圭","code":"598","english":"Uruguay","spell":"wulagui","state":"南美洲","french":"Uruguay","italian":"Uruguay","spanish":"Uruguay","japanese":"ウルグアイ","russian":"Уругвай","germen":"Uruguay"},{"abbr":"UZ","chinese":"乌兹别克斯坦","code":"998","english":"Uzbekistan","spell":"wuzibiekesitan","state":"亚洲","french":"Ouzbékistan","italian":"Uzbekistan","spanish":"Uzbekistán","japanese":"ウズベキスタン","russian":"Узбекистан","germen":"Usbekistan"},{"abbr":"VA","chinese":"梵蒂冈城","code":"379","english":"Vatican City","spell":"fandigangcheng","state":"欧洲","french":"voir Saint","italian":"Santa Sede","spanish":"Santa Sede","japanese":"聖座","russian":"Ватикан","germen":"Heiliger Stuhl"},{"abbr":"VE","chinese":"委内瑞拉","code":"58","english":"Venezuela","spell":"weineiruila","state":"北美洲","french":"Venezuela","italian":"Venezuela","spanish":"Venezuela","japanese":"ベネズエラ・ボリバル共和国","russian":"Венесуэла","germen":"Venezuela"},{"abbr":"VN","chinese":"越南","code":"84","english":"Vietnam","spell":"yuenan","state":"亚洲","french":"Viêt Nam","italian":"Vietnam","spanish":"Vietnam","japanese":"ベトナム","russian":"Вьетнам","germen":"Vietnam"},{"abbr":"YE","chinese":"也门","code":"967","english":"Yemen","spell":"yemen","state":"亚洲","french":"Yémen","italian":"Yemen","spanish":"Yemen","japanese":"イエメン","russian":"Йемен","germen":"Jemen"},{"abbr":"YU","chinese":"南斯拉夫","code":"381","english":"Yugoslavia","spell":"nansilafu","state":"欧洲","french":"Serbie","italian":"Serbia","spanish":"Serbia","japanese":"セルビア","russian":"Югославия","germen":"Serbien"},{"abbr":"ZR","chinese":"扎伊尔","code":"243","english":"Zaire","spell":"zhayier","state":"非洲","french":"Congo (Rép. dém.)","italian":"Congo (Rep. Dem.)","spanish":"Congo (Rep. Dem.)","japanese":"コンゴ民主共和国","russian":"Заир","germen":"Kongo (Dem. Rep.)"},{"abbr":"ZM","chinese":"赞比亚","code":"260","english":"Zambia","spell":"zanbiya","state":"非洲","french":"Zambie","italian":"Zambia","spanish":"Zambia","japanese":"ザンビア","russian":"Замбия","germen":"Sambia"},{"abbr":"ZW","chinese":"津巴布韦","code":"263","english":"Zimbabwe","spell":"jinbabuwei","state":"非洲","french":"Zimbabwe","italian":"Zimbabwe","spanish":"Zimbabue","japanese":"ジンバブエ","russian":"Зимбабве","germen":"Simbabwe"}]

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("OcrF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NEjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Myselfpage",
  data: function data() {
    return {
      showtype: 1,
      msg: ""
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_0__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_1__components_block_myhead__["a" /* default */]
  },
  computed: {},
  methods: {
    ShowMyinfo: function ShowMyinfo() {
      this.showtype = 1;
    },
    ShowMyorder: function ShowMyorder() {
      this.showtype = 2;
    },
    ShowMytie: function ShowMytie() {
      this.showtype = 3;
    },
    ShowMycourse: function ShowMycourse() {
      this.showtype = 4;
    },
    ShowMyrace: function ShowMyrace() {
      this.showtype = 5;
    }
  },
  mounted: function mounted() {},
  created: function created() {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_Index__ = __webpack_require__("7iae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_flexible__ = __webpack_require__("sVYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__("v2ns");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#main',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<Index/>',
  components: { Index: __WEBPACK_IMPORTED_MODULE_1__index_Index__["a" /* default */] }
});

/***/ }),

/***/ "NJFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_less_global_css__ = __webpack_require__("ORax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_less_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_less_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_json_countries_json__ = __webpack_require__("MtKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_json_Province_json__ = __webpack_require__("b3kF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_json_Province_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_json_Province_json__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "shopbuy",
  data: function data() {
    return {
      shopitem: {},
      chooseskuid: null,
      shopid: null,
      showsku: {},
      price2: 0,
      token: "",
      typename: "m",
      formData: {
        countryName: "中国", // 选中的国家
        countryId: "86",
        stationName: "北京", // 选中的省份
        stationId: "1",
        cityName: "北京", // 选中的城市
        cityId: "1",
        address: "",
        phone: "",
        name: "",
        buynum: 1
      },
      CountryList: __WEBPACK_IMPORTED_MODULE_8__assets_json_countries_json___default.a, // 国家列表
      ProvinceList: __WEBPACK_IMPORTED_MODULE_9__assets_json_Province_json___default.a, // 省份列表
      CityList: [] // 城市列表
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__["a" /* default */]
  },
  computed: {
    isChinaSelected: function isChinaSelected() {
      // 判断是否选择了中国
      return this.formData.countryName === "中国";
    }
  },
  methods: {
    gotoShoplist: function gotoShoplist() {
      this.$router.push({
        name: "shop"
      });
    },
    handlebuybtn: function handlebuybtn() {
      console.log("handlebuybtn");
      this.sendbuyPostRequest();
    },
    sendbuyPostRequest: function sendbuyPostRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var updata, url, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!_this.isButton1Disabled) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                // 禁用按钮
                _this.isButton1Disabled = true;
                // 清空之前的响应和错误信息
                _this.response = null;
                _this.error = null;
                // 验证用户输入

                if (!(!_this.formData.name || !_this.formData.countryName || !_this.formData.stationName || !_this.formData.cityName || !_this.formData.phone || !_this.formData.buynum || !_this.formData.address)) {
                  _context.next = 9;
                  break;
                }

                _this.error = "";
                return _context.abrupt("return");

              case 9:
                updata = {
                  "address": "地址:" + _this.formData.stationName + _this.formData.cityName + _this.formData.address + ",收货人:" + _this.formData.name + ",手机:" + _this.formData.phone,
                  "skuList": [{
                    "skuId": _this.chooseskuid,
                    "count": _this.formData.buynum
                  }]
                };

                // 配置 POST 请求的 URL 和数据

                url = "https://ttserver.aizhuotice.online/api/v1/goods/order";

                console.log(_this.formData);
                // 发起 POST 请求
                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, updata, {
                  headers: {
                    "Content-Type": "application/json",
                    token: _this.token
                  }
                });

              case 14:
                response = _context.sent;

                // 处理成功响应
                _this.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this.response);
                if (_this.response.code == 200) {
                  alert("提交成功");
                  // localStorage.setItem('token', this.response.data.token);
                  _this.gotoShoplist();
                }
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }

              case 23:
                _context.prev = 23;

                // 无论成功或失败，都重新启用按钮
                _this.isButton1Disabled = false;
                return _context.finish(23);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 20, 23, 26]]);
      }))();
    },
    CheckShopitemList: function CheckShopitemList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                params = {
                  id: _this2.shopid
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/SKU";
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                  }
                });

              case 7:
                response = _context2.sent;

                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response.code);
                if (_this2.response.code == 200) {
                  // console.log(this.response.data);
                  _this2.shopitem = _this2.response.data;
                  //   console.log(this.shopitem);

                  _this2.shopitem.skuList.forEach(function (element) {
                    if (_this2.chooseskuid == element.id) {
                      _this2.showsku = element;
                      _this2.price2 = element.price;
                      if (element.skuValue1.length > 0) {
                        _this2.typename = element.skuValue1;
                      }
                      if (element.skuValue2.length > 0) {
                        _this2.typename = element.skuValue1 + " " + element.skuValue2;
                      }
                    }
                  });
                } else {}
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }
                console.log(_this2.error);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 12]]);
      }))();
    },
    updataCountry: function updataCountry() {
      var _this3 = this;

      var selectedCountry = this.CountryList.find(function (country) {
        return country.chinese === _this3.formData.countryName;
      });
      if (selectedCountry) {
        var chinese = selectedCountry.chinese; // 获取中文名
        var code = selectedCountry.code; // 获取国家代码
        console.log("选中的国家:", chinese);
        console.log("国家代码:", code);
        this.formData.countryId = code;
      }
    },
    showProvince: function showProvince() {
      console.log(this.formData.countryName);
      return this.formData.countryName === "中国";
    },
    showCity: function showCity() {
      return this.showProvince && this.formData.stationName;
    },
    updateProvince: function updateProvince() {
      var _this4 = this;

      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.stationName);
      // console.log(this.ProvinceList[0].name);
      // console.log(this.ProvinceList[1].name);
      var code = this.findstationCodeByName(this.formData.stationName);
      console.log(code);
      this.formData.stationId = code;
      if (this.formData.stationName) {
        var stationName = this.ProvinceList.find(function (province) {
          return province.name === _this4.formData.stationName;
        });
        console.log(stationName);
        this.CityList = stationName ? stationName.children : [];
        this.formData.cityName = ""; // 清空城市选择
      } else {
        this.CityList = []; // 清空城市列表
        this.formData.cityName = ""; // 清空城市选择
      }
    },
    getProvinceName: function getProvinceName(code) {
      // 根据省份代码获取省份名称
      var province = this.ProvinceList.find(function (province) {
        return province.code === code;
      });
      return province ? province.name : "";
    },
    getCityName: function getCityName(code) {
      // 根据城市代码获取城市名称
      var city = this.CityList.find(function (city) {
        return city.code === code;
      });
      return city ? city.name : "";
    },
    findstationCodeByName: function findstationCodeByName(targetName) {
      // console.log(targetName);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.ProvinceList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.name === targetName) {
            return item.code; // 找到匹配项，直接返回 code
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null; // 如果找不到，返回 null
    },
    findCityCodeByName: function findCityCodeByName(data, targetName) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.name === targetName) {
            return item.code; // 找到匹配项，直接返回 code
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null; // 如果找不到，返回 null
    },
    updateCity: function updateCity() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.cityName);
      var code = this.findCityCodeByName(this.CityList, this.formData.cityName);
      console.log(code);
      this.formData.cityId = code;
    }
  },
  watch: {
    countryName: function countryName(newVal) {
      // 当用户切换国家时，如果不是中国，清空省份和城市选择
      if (!this.isChinaSelected) {
        this.formData.stationName = "";
        this.formData.cityName = "";
        this.CityList = [];
      }
    }
  },
  mounted: function mounted() {
    this.token = localStorage.getItem("token");
    this.shopid = this.$route.params.id;
    this.chooseskuid = this.$route.params.sku;
    // console.log(this.shopid);
    // console.log(this.chooseskuid);
    this.CheckShopitemList();
  },
  created: function created() {
    //  console.log(this.$route.params);
  }
});

/***/ }),

/***/ "NfIJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O1zH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/tech.e22048d.jpg";

/***/ }),

/***/ "OQjs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ORax":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OcrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P10X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type1hover.3472f04.jpg";

/***/ }),

/***/ "PC6g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type1bg.a303126.jpg";

/***/ }),

/***/ "PIy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

var BaseUrl = "http://47.94.236.45:9000/";

function buildUrl(url) {
    return BaseUrl + url;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            msg: ''

        };
    }
});

/***/ }),

/***/ "Phft":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3lf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SSAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('div',{staticClass:"topbar"}),_vm._v(" "),_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('div',{staticClass:"headerimg"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"http://efun-oss.oss-cn-beijing.aliyuncs.com/banner/banner-1.jpg"}})])])]),_vm._v(" "),_c('swiper-slide',[_c('div',{staticClass:"headerimg"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"http://efun-oss.oss-cn-beijing.aliyuncs.com/banner/banner-2.jpg"}})])])]),_vm._v(" "),_c('swiper-slide',[_c('div',{staticClass:"headerimg"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"http://efun-oss.oss-cn-beijing.aliyuncs.com/banner/banner-3.jpg"}})])])]),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],1),_vm._v(" "),_c('WawaList',{attrs:{"wawadata":_vm.wawadata}}),_vm._v(" "),_c('footerBlock',{attrs:{"hover":1}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TdoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "regPage",
  data: function data() {
    return {
      msg: "",
      showloginbox: true,
      showqrcode: true,
      showregbox: false,
      response: null, // 存储服务器返回的数据
      error: null, // 存储请求错误信息
      formData: {
        username: "", // 用户名（手机号或邮箱）
        password: "" //  密码
      },
      formData2: {
        username: "", // 用户名（手机号或邮箱）
        password: "" // 验证码
      },
      formData3: {
        username: "", // 用户名（手机号或邮箱）
        password: "", // 密码
        password2: "", // 密码
        code: "" // 验证码
      },
      isButton1Disabled: false,
      isButton2Disabled: false,
      isButton3Disabled: false

    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      console.log("gotoHomePage");
      this.$router.push({
        name: "Index"
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: "mypage"
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: "Setpage"
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: "Rankpage"
      });
    },
    handleMousepos1: function handleMousepos1() {
      console.log("handleMousepos1");
      this.showqrcode = true;
    },
    handleMousepos2: function handleMousepos2() {
      console.log("handleMousepos2");
      this.showqrcode = false;
    },
    handleMouseposbtn: function handleMouseposbtn() {
      console.log("handleMouseRtype3");
      this.showposbtn = true;
    },
    handleMouseoutPosbtn: function handleMouseoutPosbtn() {
      console.log("handleMouseoutRtype3");
      this.showposbtn = false;
    },
    handleloginbtn: function handleloginbtn() {
      console.log("handleloginbtn");
      this.sendloginPostRequest();
    },
    sendloginPostRequest: function sendloginPostRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, postData, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this.response = null;
                _this.error = null;
                // 验证用户输入

                if (!(!_this.formData.username || !_this.formData.password)) {
                  _context.next = 6;
                  break;
                }

                _this.error = "请输入用户名和密码";
                return _context.abrupt("return");

              case 6:
                if (!_this.isButton2Disabled) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                // 禁用按钮
                _this.isButton2Disabled = true;
                // 配置 POST 请求的 URL 和数据
                url = " https://ttserver.aizhuotice.online/api/v1/local/login";
                postData = {
                  name: "phoneNumber",
                  password: "1234"
                };
                // 发起 POST 请求

                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, _this.formData);

              case 13:
                response = _context.sent;

                // 处理成功响应
                _this.response = response.data; // 将返回的数据存储到组件状态　
                if (_this.response.code == 200) {

                  localStorage.setItem('token', _this.response.data.token);
                  alert("登录成功");
                  _this.gotoHomePage();
                } else {
                  alert(_this.response.msg);
                }
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }

              case 21:
                _context.prev = 21;

                // 无论成功或失败，都重新启用按钮
                _this.isButton2Disabled = false;
                return _context.finish(21);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 18, 21, 24]]);
      }))();
    },

    handlelogincodebtn: function handlelogincodebtn() {
      console.log("handlelogincodebtn");
      this.sendlogincodePostRequest();
    },
    sendlogincodePostRequest: function sendlogincodePostRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                // 验证用户输入

                if (!(!_this2.formData2.username || !_this2.formData2.password)) {
                  _context2.next = 6;
                  break;
                }

                _this2.error = "请输入用户名和密码";
                return _context2.abrupt("return");

              case 6:
                if (!_this2.isButton3Disabled) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:
                // 禁用按钮
                _this2.isButton3Disabled = true;
                // 配置 POST 请求的 URL 和数据
                url = " https://ttserver.aizhuotice.online/api/v1/local/login";
                // const postData = {
                //   name: "phoneNumber",
                //   password: "1234",
                // };　
                // 发起 POST 请求

                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, _this2.formData2);

              case 12:
                response = _context2.sent;

                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                if (_this2.response.code == 200) {
                  localStorage.setItem('token', _this2.response.data.token);
                  alert("登录成功");
                  gotoHomePage();
                }
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 17]]);
      }))();
    },


    handleregbtn: function handleregbtn() {
      console.log("handleregbtn");
      this.sendRegPostRequest();
    },
    sendRegPostRequest: function sendRegPostRequest() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!_this3.isButton1Disabled) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                // 禁用按钮
                _this3.isButton1Disabled = true;
                // 清空之前的响应和错误信息
                _this3.response = null;
                _this3.error = null;
                // 验证用户输入

                if (!(!_this3.formData3.username || !_this3.formData3.password || !_this3.formData3.password2 || !_this3.formData3.code)) {
                  _context3.next = 9;
                  break;
                }

                _this3.error = "请输入用户名和密码";
                return _context3.abrupt("return");

              case 9:
                if (!(_this3.formData3.password !== _this3.formData3.password2)) {
                  _context3.next = 12;
                  break;
                }

                _this3.error = "两次密码不一致";
                return _context3.abrupt("return");

              case 12:
                // 配置 POST 请求的 URL 和数据
                url = "https://ttserver.aizhuotice.online/api/v1/local/register";
                // const postData = {
                //   phoneNumber: "12345",
                //   password: "1234",
                // };　
                // 发起 POST 请求

                _context3.next = 15;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, _this3.formData3);

              case 15:
                response = _context3.sent;

                // 处理成功响应
                _this3.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this3.response);
                if (_this3.response.code == 200) {
                  alert("注册成功");
                  _this3.showloginbox = true;
                  _this3.showregbox = false;
                  _this3.showqrcode = false;
                }
                _context3.next = 24;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](0);

                // 处理请求错误
                if (_context3.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this3.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context3.t0.response.status + " - " + _context3.t0.response.statusText;
                } else if (_context3.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this3.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this3.error = "\u8BF7\u6C42\u5931\u8D25: " + _context3.t0.message;
                }

              case 24:
                _context3.prev = 24;

                // 无论成功或失败，都重新启用按钮
                _this3.isButton1Disabled = false;
                return _context3.finish(24);

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 21, 24, 27]]);
      }))();
    },

    handleforgetpsw: function handleforgetpsw() {
      console.log("handleforgetpsw");
    },
    handlegotoreg: function handlegotoreg() {
      console.log("handlegotoreg");
      this.showloginbox = false;
      this.showregbox = true;
    },
    handlerSendpsw: function handlerSendpsw() {
      console.log("handlerSendpsw");
    },
    handlebacklogin: function handlebacklogin() {
      console.log("handlebacklogin");
      this.showloginbox = true;
      this.showregbox = false;
    }
  },
  mounted: function mounted() {},
  created: function created() {}
});

/***/ }),

/***/ "Tv8t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6Uh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/posbtn1.4346d20.jpg";

/***/ }),

/***/ "VCAi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VIIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("yRbr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325c18c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("KoPK");
function injectStyle (ssrContext) {
  __webpack_require__("as93")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-325c18c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325c18c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W0Op":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__ = __webpack_require__("TdoI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a80cc19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__ = __webpack_require__("Y5dL");
function injectStyle (ssrContext) {
  __webpack_require__("kswo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a80cc19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a80cc19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WkIM":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "XwAm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type2bg.ab8e361.jpg";

/***/ }),

/***/ "XzAS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/pos2img.b0578ec.jpg";

/***/ }),

/***/ "Y5dL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"hometiebox"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showloginbox),expression:"showloginbox"}],staticClass:"loginbox"},[_c('div',{staticClass:"posline"},[_c('div',{staticClass:"myposline1",on:{"click":_vm.handleMousepos1}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showqrcode),expression:"showqrcode"}],staticClass:"poschoose"},[_vm._v(" 验证码登录 ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showqrcode),expression:"!showqrcode"}]},[_vm._v("验证码登录")])])]),_vm._v(" "),_c('div',{staticClass:"myposline2",on:{"click":_vm.handleMousepos2}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showqrcode),expression:"showqrcode"}]},[_vm._v("密码登录")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showqrcode),expression:"!showqrcode"}],staticClass:"poschoose"},[_vm._v("密码登录")])])])]),_vm._v(" "),_c('div',{staticClass:"regtextbox"},[_vm._v("您所在地区仅支持手机号、微信登录")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showqrcode),expression:"!showqrcode"}],staticClass:"pswloginbox"},[_c('div',{staticClass:"regitem2"},[_c('div',{staticClass:"reginput1"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.username),expression:"formData.username"}],attrs:{"type":"text","placeholder":"请输入手机号"},domProps:{"value":(_vm.formData.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"reginput2"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.formData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"regtextbox2"},[_vm._v("\n            注册登录即表示您已阅读并同意我们的用户协议和隐私策略\n          ")]),_vm._v(" "),_c('div',{staticClass:"regbtn",class:{ disabled: _vm.isButton2Disabled },on:{"click":_vm.handleloginbtn}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.isButton2Disabled ? '登录中...' : '登录'))])])]),_vm._v(" "),_c('div',{staticClass:"regtextbox3"},[_c('div',{staticClass:"forgetpsw",on:{"click":_vm.handleforgetpsw}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("忘记密码")])]),_vm._v(" "),_c('div',{staticClass:"gotoreg",on:{"click":_vm.handlegotoreg}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("立即注册")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showqrcode),expression:"showqrcode"}],staticClass:"codeloginbox"},[_c('div',{staticClass:"regitem2"},[_c('div',{staticClass:"reginput1"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData2.username),expression:"formData2.username"}],attrs:{"type":"text","placeholder":"请输入手机号"},domProps:{"value":(_vm.formData2.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData2, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"reginput2"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData2.password),expression:"formData2.password"}],attrs:{"type":"password","placeholder":"请输入验证码"},domProps:{"value":(_vm.formData2.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData2, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"reginput2sendbtn",on:{"click":_vm.handlerSendpsw}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("发送验证码")])])]),_vm._v(" "),_c('div',{staticClass:"regtextbox2"},[_vm._v("\n            注册登录即表示您已阅读并同意我们的用户协议和隐私策略\n          ")]),_vm._v(" "),_c('div',{staticClass:"regbtn",class:{ disabled: _vm.isButton3Disabled },on:{"click":_vm.handlelogincodebtn}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.isButton3Disabled ? '登录中...' : '登录'))])])]),_vm._v(" "),_c('div',{staticClass:"regtextbox3"},[_c('div',{staticClass:"forgetpsw",on:{"click":_vm.handleforgetpsw}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("忘记密码")])]),_vm._v(" "),_c('div',{staticClass:"gotoreg",on:{"click":_vm.handlegotoreg}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("立即注册")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showregbox),expression:"showregbox"}],staticClass:"regbox"},[_c('div',{staticClass:"regtextbox"},[_vm._v("您所在地区仅支持手机号、微信登录")]),_vm._v(" "),_c('div',{staticClass:"codeloginbox"},[_c('div',{staticClass:"regitem2"},[_c('div',{staticClass:"reginput1"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData3.username),expression:"formData3.username"}],attrs:{"type":"text","placeholder":"请输入手机号"},domProps:{"value":(_vm.formData3.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData3, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"reginput2"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData3.code),expression:"formData3.code"}],attrs:{"type":"password","placeholder":"请输入验证码"},domProps:{"value":(_vm.formData3.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData3, "code", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"reginput2sendbtn",on:{"click":_vm.handlerSendpsw}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("发送验证码")])])]),_vm._v(" "),_c('div',{staticClass:"reginput3"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData3.password),expression:"formData3.password"}],attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.formData3.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData3, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"reginput4"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData3.password2),expression:"formData3.password2"}],attrs:{"type":"password","placeholder":"请再次输入密码"},domProps:{"value":(_vm.formData3.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData3, "password2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"regtextbox2"},[_vm._v("\n            注册登录即表示您已阅读并同意我们的用户协议和隐私策略\n          ")]),_vm._v(" "),_c('div',{staticClass:"regbtn",class:{ disabled: _vm.isButton1Disabled },on:{"click":_vm.handleregbtn}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.isButton1Disabled ? '注册中...' : '注册'))])]),_vm._v(" "),_c('div',{staticClass:"regtextbox3"},[_c('div',{staticClass:"forgetpsw",on:{"click":_vm.handlebacklogin}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("返回登陆")])])])])])])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hometieboximg"},[_c('img',{attrs:{"src":__webpack_require__("eD7S"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("I5/u"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("06MH"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("I5/u"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("06MH"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("I5/u"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("AJIP"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("06MH"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("06MH"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Setpage__ = __webpack_require__("B+zM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reg__ = __webpack_require__("W0Op");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RegTie__ = __webpack_require__("5s46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_clublist__ = __webpack_require__("BVHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_clubdes__ = __webpack_require__("s9wN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_racelist__ = __webpack_require__("jCJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_racedes__ = __webpack_require__("uS1S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shop__ = __webpack_require__("pt6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shopdes__ = __webpack_require__("20Rq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_courselist__ = __webpack_require__("mrS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_shopbuy__ = __webpack_require__("xbwT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Myselfpage__ = __webpack_require__("J/AV");
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history', // 或者 'hash'
  routes: [{
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index__["a" /* default */]
  }, {
    path: '/set',
    name: 'Setpage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Setpage__["a" /* default */]
  }, {
    path: '/reg',
    name: 'regPage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Reg__["a" /* default */]
  }, {
    path: '/regtie',
    name: 'regTiePage',
    component: __WEBPACK_IMPORTED_MODULE_6__components_RegTie__["a" /* default */]
  }, {
    path: '/clublist',
    name: 'clublist',
    component: __WEBPACK_IMPORTED_MODULE_7__components_clublist__["a" /* default */]
  }, {
    path: '/clubdes/:id',
    name: 'clubdes',
    component: __WEBPACK_IMPORTED_MODULE_8__components_clubdes__["a" /* default */]
  }, {
    path: '/racelist',
    name: 'racelist',
    component: __WEBPACK_IMPORTED_MODULE_9__components_racelist__["a" /* default */]
  }, {
    path: '/racedes/:id',
    name: 'racedes',
    component: __WEBPACK_IMPORTED_MODULE_10__components_racedes__["a" /* default */]
  }, {
    path: '/shop',
    name: 'shop',
    component: __WEBPACK_IMPORTED_MODULE_11__components_shop__["a" /* default */]
  }, {
    path: '/shopdes/:id',
    name: 'shopdes',
    component: __WEBPACK_IMPORTED_MODULE_12__components_shopdes__["a" /* default */]
  }, {
    path: '/courselist',
    name: 'courselist',
    component: __WEBPACK_IMPORTED_MODULE_13__components_courselist__["a" /* default */]
  }, {
    path: '/shopbuy/:id/:sku',
    name: 'shopbuy',
    component: __WEBPACK_IMPORTED_MODULE_14__components_shopbuy__["a" /* default */]
  }, {
    path: '/myselfpage',
    name: 'Myselfpage',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Myselfpage__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // 如果存在 savedPosition，则说明是通过浏览器的前进/后退按钮触发的
    console.log('scrollBehavior called:', { to: to, from: from, savedPosition: savedPosition });
    if (savedPosition) {
      return savedPosition;
    }
    // 否则，默认滚动到页面顶部
    return { x: 0, y: 0 };
  }
}));

// // 兼容性处理：手动滚动到顶部
// Router.afterEach((to, from) => {
//   setTimeout(() => {
//     window.scrollTo(0, 0);
//   }, 0);
// });

/***/ }),

/***/ "YsnE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ZnGw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/club-2.b0b00af.jpg";

/***/ }),

/***/ "as93":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b3kF":
/***/ (function(module, exports) {

module.exports = [{"code":"11","name":"北京市","children":[{"code":"110101","name":"东城区"},{"code":"110102","name":"西城区"},{"code":"110105","name":"朝阳区"},{"code":"110106","name":"丰台区"},{"code":"110107","name":"石景山区"},{"code":"110108","name":"海淀区"},{"code":"110109","name":"门头沟区"},{"code":"110111","name":"房山区"},{"code":"110112","name":"通州区"},{"code":"110113","name":"顺义区"},{"code":"110114","name":"昌平区"},{"code":"110115","name":"大兴区"},{"code":"110116","name":"怀柔区"},{"code":"110117","name":"平谷区"},{"code":"110118","name":"密云区"},{"code":"110119","name":"延庆区"}]},{"code":"12","name":"天津市","children":[{"code":"120101","name":"和平区"},{"code":"120102","name":"河东区"},{"code":"120103","name":"河西区"},{"code":"120104","name":"南开区"},{"code":"120105","name":"河北区"},{"code":"120106","name":"红桥区"},{"code":"120110","name":"东丽区"},{"code":"120111","name":"西青区"},{"code":"120112","name":"津南区"},{"code":"120113","name":"北辰区"},{"code":"120114","name":"武清区"},{"code":"120115","name":"宝坻区"},{"code":"120116","name":"滨海新区"},{"code":"120117","name":"宁河区"},{"code":"120118","name":"静海区"},{"code":"120119","name":"蓟州区"}]},{"code":"13","name":"河北省","children":[{"code":"1301","name":"石家庄市"},{"code":"1302","name":"唐山市"},{"code":"1303","name":"秦皇岛市"},{"code":"1304","name":"邯郸市"},{"code":"1305","name":"邢台市"},{"code":"1306","name":"保定市"},{"code":"1307","name":"张家口市"},{"code":"1308","name":"承德市"},{"code":"1309","name":"沧州市"},{"code":"1310","name":"廊坊市"},{"code":"1311","name":"衡水市"}]},{"code":"14","name":"山西省","children":[{"code":"1401","name":"太原市"},{"code":"1402","name":"大同市"},{"code":"1403","name":"阳泉市"},{"code":"1404","name":"长治市"},{"code":"1405","name":"晋城市"},{"code":"1406","name":"朔州市"},{"code":"1407","name":"晋中市"},{"code":"1408","name":"运城市"},{"code":"1409","name":"忻州市"},{"code":"1410","name":"临汾市"},{"code":"1411","name":"吕梁市"}]},{"code":"15","name":"内蒙古自治区","children":[{"code":"1501","name":"呼和浩特市"},{"code":"1502","name":"包头市"},{"code":"1503","name":"乌海市"},{"code":"1504","name":"赤峰市"},{"code":"1505","name":"通辽市"},{"code":"1506","name":"鄂尔多斯市"},{"code":"1507","name":"呼伦贝尔市"},{"code":"1508","name":"巴彦淖尔市"},{"code":"1509","name":"乌兰察布市"},{"code":"1522","name":"兴安盟"},{"code":"1525","name":"锡林郭勒盟"},{"code":"1529","name":"阿拉善盟"}]},{"code":"21","name":"辽宁省","children":[{"code":"2101","name":"沈阳市"},{"code":"2102","name":"大连市"},{"code":"2103","name":"鞍山市"},{"code":"2104","name":"抚顺市"},{"code":"2105","name":"本溪市"},{"code":"2106","name":"丹东市"},{"code":"2107","name":"锦州市"},{"code":"2108","name":"营口市"},{"code":"2109","name":"阜新市"},{"code":"2110","name":"辽阳市"},{"code":"2111","name":"盘锦市"},{"code":"2112","name":"铁岭市"},{"code":"2113","name":"朝阳市"},{"code":"2114","name":"葫芦岛市"}]},{"code":"22","name":"吉林省","children":[{"code":"2201","name":"长春市"},{"code":"2202","name":"吉林市"},{"code":"2203","name":"四平市"},{"code":"2204","name":"辽源市"},{"code":"2205","name":"通化市"},{"code":"2206","name":"白山市"},{"code":"2207","name":"松原市"},{"code":"2208","name":"白城市"},{"code":"2224","name":"延边朝鲜族自治州"}]},{"code":"23","name":"黑龙江省","children":[{"code":"2301","name":"哈尔滨市"},{"code":"2302","name":"齐齐哈尔市"},{"code":"2303","name":"鸡西市"},{"code":"2304","name":"鹤岗市"},{"code":"2305","name":"双鸭山市"},{"code":"2306","name":"大庆市"},{"code":"2307","name":"伊春市"},{"code":"2308","name":"佳木斯市"},{"code":"2309","name":"七台河市"},{"code":"2310","name":"牡丹江市"},{"code":"2311","name":"黑河市"},{"code":"2312","name":"绥化市"},{"code":"2327","name":"大兴安岭地区"}]},{"code":"31","name":"上海市","children":[{"code":"310101","name":"黄浦区"},{"code":"310104","name":"徐汇区"},{"code":"310105","name":"长宁区"},{"code":"310106","name":"静安区"},{"code":"310107","name":"普陀区"},{"code":"310109","name":"虹口区"},{"code":"310110","name":"杨浦区"},{"code":"310112","name":"闵行区"},{"code":"310113","name":"宝山区"},{"code":"310114","name":"嘉定区"},{"code":"310115","name":"浦东新区"},{"code":"310116","name":"金山区"},{"code":"310117","name":"松江区"},{"code":"310118","name":"青浦区"},{"code":"310120","name":"奉贤区"},{"code":"310151","name":"崇明区"}]},{"code":"32","name":"江苏省","children":[{"code":"3201","name":"南京市"},{"code":"3202","name":"无锡市"},{"code":"3203","name":"徐州市"},{"code":"3204","name":"常州市"},{"code":"3205","name":"苏州市"},{"code":"3206","name":"南通市"},{"code":"3207","name":"连云港市"},{"code":"3208","name":"淮安市"},{"code":"3209","name":"盐城市"},{"code":"3210","name":"扬州市"},{"code":"3211","name":"镇江市"},{"code":"3212","name":"泰州市"},{"code":"3213","name":"宿迁市"}]},{"code":"33","name":"浙江省","children":[{"code":"3301","name":"杭州市"},{"code":"3302","name":"宁波市"},{"code":"3303","name":"温州市"},{"code":"3304","name":"嘉兴市"},{"code":"3305","name":"湖州市"},{"code":"3306","name":"绍兴市"},{"code":"3307","name":"金华市"},{"code":"3308","name":"衢州市"},{"code":"3309","name":"舟山市"},{"code":"3310","name":"台州市"},{"code":"3311","name":"丽水市"}]},{"code":"34","name":"安徽省","children":[{"code":"3401","name":"合肥市"},{"code":"3402","name":"芜湖市"},{"code":"3403","name":"蚌埠市"},{"code":"3404","name":"淮南市"},{"code":"3405","name":"马鞍山市"},{"code":"3406","name":"淮北市"},{"code":"3407","name":"铜陵市"},{"code":"3408","name":"安庆市"},{"code":"3410","name":"黄山市"},{"code":"3411","name":"滁州市"},{"code":"3412","name":"阜阳市"},{"code":"3413","name":"宿州市"},{"code":"3415","name":"六安市"},{"code":"3416","name":"亳州市"},{"code":"3417","name":"池州市"},{"code":"3418","name":"宣城市"}]},{"code":"35","name":"福建省","children":[{"code":"3501","name":"福州市"},{"code":"3502","name":"厦门市"},{"code":"3503","name":"莆田市"},{"code":"3504","name":"三明市"},{"code":"3505","name":"泉州市"},{"code":"3506","name":"漳州市"},{"code":"3507","name":"南平市"},{"code":"3508","name":"龙岩市"},{"code":"3509","name":"宁德市"}]},{"code":"36","name":"江西省","children":[{"code":"3601","name":"南昌市"},{"code":"3602","name":"景德镇市"},{"code":"3603","name":"萍乡市"},{"code":"3604","name":"九江市"},{"code":"3605","name":"新余市"},{"code":"3606","name":"鹰潭市"},{"code":"3607","name":"赣州市"},{"code":"3608","name":"吉安市"},{"code":"3609","name":"宜春市"},{"code":"3610","name":"抚州市"},{"code":"3611","name":"上饶市"}]},{"code":"37","name":"山东省","children":[{"code":"3701","name":"济南市"},{"code":"3702","name":"青岛市"},{"code":"3703","name":"淄博市"},{"code":"3704","name":"枣庄市"},{"code":"3705","name":"东营市"},{"code":"3706","name":"烟台市"},{"code":"3707","name":"潍坊市"},{"code":"3708","name":"济宁市"},{"code":"3709","name":"泰安市"},{"code":"3710","name":"威海市"},{"code":"3711","name":"日照市"},{"code":"3713","name":"临沂市"},{"code":"3714","name":"德州市"},{"code":"3715","name":"聊城市"},{"code":"3716","name":"滨州市"},{"code":"3717","name":"菏泽市"}]},{"code":"41","name":"河南省","children":[{"code":"4101","name":"郑州市"},{"code":"4102","name":"开封市"},{"code":"4103","name":"洛阳市"},{"code":"4104","name":"平顶山市"},{"code":"4105","name":"安阳市"},{"code":"4106","name":"鹤壁市"},{"code":"4107","name":"新乡市"},{"code":"4108","name":"焦作市"},{"code":"4109","name":"濮阳市"},{"code":"4110","name":"许昌市"},{"code":"4111","name":"漯河市"},{"code":"4112","name":"三门峡市"},{"code":"4113","name":"南阳市"},{"code":"4114","name":"商丘市"},{"code":"4115","name":"信阳市"},{"code":"4116","name":"周口市"},{"code":"4117","name":"驻马店市"},{"code":"419001","name":"济源市"}]},{"code":"42","name":"湖北省","children":[{"code":"4201","name":"武汉市"},{"code":"4202","name":"黄石市"},{"code":"4203","name":"十堰市"},{"code":"4205","name":"宜昌市"},{"code":"4206","name":"襄阳市"},{"code":"4207","name":"鄂州市"},{"code":"4208","name":"荆门市"},{"code":"4209","name":"孝感市"},{"code":"4210","name":"荆州市"},{"code":"4211","name":"黄冈市"},{"code":"4212","name":"咸宁市"},{"code":"4213","name":"随州市"},{"code":"4228","name":"恩施土家族苗族自治州"},{"code":"429004","name":"仙桃市"},{"code":"429005","name":"潜江市"},{"code":"429006","name":"天门市"},{"code":"429021","name":"神农架林区"}]},{"code":"43","name":"湖南省","children":[{"code":"4301","name":"长沙市"},{"code":"4302","name":"株洲市"},{"code":"4303","name":"湘潭市"},{"code":"4304","name":"衡阳市"},{"code":"4305","name":"邵阳市"},{"code":"4306","name":"岳阳市"},{"code":"4307","name":"常德市"},{"code":"4308","name":"张家界市"},{"code":"4309","name":"益阳市"},{"code":"4310","name":"郴州市"},{"code":"4311","name":"永州市"},{"code":"4312","name":"怀化市"},{"code":"4313","name":"娄底市"},{"code":"4331","name":"湘西土家族苗族自治州"}]},{"code":"44","name":"广东省","children":[{"code":"4401","name":"广州市"},{"code":"4402","name":"韶关市"},{"code":"4403","name":"深圳市"},{"code":"4404","name":"珠海市"},{"code":"4405","name":"汕头市"},{"code":"4406","name":"佛山市"},{"code":"4407","name":"江门市"},{"code":"4408","name":"湛江市"},{"code":"4409","name":"茂名市"},{"code":"4412","name":"肇庆市"},{"code":"4413","name":"惠州市"},{"code":"4414","name":"梅州市"},{"code":"4415","name":"汕尾市"},{"code":"4416","name":"河源市"},{"code":"4417","name":"阳江市"},{"code":"4418","name":"清远市"},{"code":"4419","name":"东莞市"},{"code":"4420","name":"中山市"},{"code":"4451","name":"潮州市"},{"code":"4452","name":"揭阳市"},{"code":"4453","name":"云浮市"}]},{"code":"45","name":"广西壮族自治区","children":[{"code":"4501","name":"南宁市"},{"code":"4502","name":"柳州市"},{"code":"4503","name":"桂林市"},{"code":"4504","name":"梧州市"},{"code":"4505","name":"北海市"},{"code":"4506","name":"防城港市"},{"code":"4507","name":"钦州市"},{"code":"4508","name":"贵港市"},{"code":"4509","name":"玉林市"},{"code":"4510","name":"百色市"},{"code":"4511","name":"贺州市"},{"code":"4512","name":"河池市"},{"code":"4513","name":"来宾市"},{"code":"4514","name":"崇左市"}]},{"code":"46","name":"海南省","children":[{"code":"4601","name":"海口市"},{"code":"4602","name":"三亚市"},{"code":"4603","name":"三沙市"},{"code":"4604","name":"儋州市"},{"code":"469001","name":"五指山市"},{"code":"469002","name":"琼海市"},{"code":"469005","name":"文昌市"},{"code":"469006","name":"万宁市"},{"code":"469007","name":"东方市"},{"code":"469021","name":"定安县"},{"code":"469022","name":"屯昌县"},{"code":"469023","name":"澄迈县"},{"code":"469024","name":"临高县"},{"code":"469025","name":"白沙黎族自治县"},{"code":"469026","name":"昌江黎族自治县"},{"code":"469027","name":"乐东黎族自治县"},{"code":"469028","name":"陵水黎族自治县"},{"code":"469029","name":"保亭黎族苗族自治县"},{"code":"469030","name":"琼中黎族苗族自治县"}]},{"code":"50","name":"重庆市","children":[{"code":"500101","name":"万州区"},{"code":"500102","name":"涪陵区"},{"code":"500103","name":"渝中区"},{"code":"500104","name":"大渡口区"},{"code":"500105","name":"江北区"},{"code":"500106","name":"沙坪坝区"},{"code":"500107","name":"九龙坡区"},{"code":"500108","name":"南岸区"},{"code":"500109","name":"北碚区"},{"code":"500110","name":"綦江区"},{"code":"500111","name":"大足区"},{"code":"500112","name":"渝北区"},{"code":"500113","name":"巴南区"},{"code":"500114","name":"黔江区"},{"code":"500115","name":"长寿区"},{"code":"500116","name":"江津区"},{"code":"500117","name":"合川区"},{"code":"500118","name":"永川区"},{"code":"500119","name":"南川区"},{"code":"500120","name":"璧山区"},{"code":"500151","name":"铜梁区"},{"code":"500152","name":"潼南区"},{"code":"500153","name":"荣昌区"},{"code":"500154","name":"开州区"},{"code":"500155","name":"梁平区"},{"code":"500156","name":"武隆区"},{"code":"500229","name":"城口县"},{"code":"500230","name":"丰都县"},{"code":"500231","name":"垫江县"},{"code":"500233","name":"忠县"},{"code":"500235","name":"云阳县"},{"code":"500236","name":"奉节县"},{"code":"500237","name":"巫山县"},{"code":"500238","name":"巫溪县"},{"code":"500240","name":"石柱土家族自治县"},{"code":"500241","name":"秀山土家族苗族自治县"},{"code":"500242","name":"酉阳土家族苗族自治县"},{"code":"500243","name":"彭水苗族土家族自治县"}]},{"code":"51","name":"四川省","children":[{"code":"5101","name":"成都市"},{"code":"5103","name":"自贡市"},{"code":"5104","name":"攀枝花市"},{"code":"5105","name":"泸州市"},{"code":"5106","name":"德阳市"},{"code":"5107","name":"绵阳市"},{"code":"5108","name":"广元市"},{"code":"5109","name":"遂宁市"},{"code":"5110","name":"内江市"},{"code":"5111","name":"乐山市"},{"code":"5113","name":"南充市"},{"code":"5114","name":"眉山市"},{"code":"5115","name":"宜宾市"},{"code":"5116","name":"广安市"},{"code":"5117","name":"达州市"},{"code":"5118","name":"雅安市"},{"code":"5119","name":"巴中市"},{"code":"5120","name":"资阳市"},{"code":"5132","name":"阿坝藏族羌族自治州"},{"code":"5133","name":"甘孜藏族自治州"},{"code":"5134","name":"凉山彝族自治州"}]},{"code":"52","name":"贵州省","children":[{"code":"5201","name":"贵阳市"},{"code":"5202","name":"六盘水市"},{"code":"5203","name":"遵义市"},{"code":"5204","name":"安顺市"},{"code":"5205","name":"毕节市"},{"code":"5206","name":"铜仁市"},{"code":"5223","name":"黔西南布依族苗族自治州"},{"code":"5226","name":"黔东南苗族侗族自治州"},{"code":"5227","name":"黔南布依族苗族自治州"}]},{"code":"53","name":"云南省","children":[{"code":"5301","name":"昆明市"},{"code":"5303","name":"曲靖市"},{"code":"5304","name":"玉溪市"},{"code":"5305","name":"保山市"},{"code":"5306","name":"昭通市"},{"code":"5307","name":"丽江市"},{"code":"5308","name":"普洱市"},{"code":"5309","name":"临沧市"},{"code":"5323","name":"楚雄彝族自治州"},{"code":"5325","name":"红河哈尼族彝族自治州"},{"code":"5326","name":"文山壮族苗族自治州"},{"code":"5328","name":"西双版纳傣族自治州"},{"code":"5329","name":"大理白族自治州"},{"code":"5331","name":"德宏傣族景颇族自治州"},{"code":"5333","name":"怒江傈僳族自治州"},{"code":"5334","name":"迪庆藏族自治州"}]},{"code":"54","name":"西藏自治区","children":[{"code":"5401","name":"拉萨市"},{"code":"5402","name":"日喀则市"},{"code":"5403","name":"昌都市"},{"code":"5404","name":"林芝市"},{"code":"5405","name":"山南市"},{"code":"5406","name":"那曲市"},{"code":"5425","name":"阿里地区"}]},{"code":"61","name":"陕西省","children":[{"code":"6101","name":"西安市"},{"code":"6102","name":"铜川市"},{"code":"6103","name":"宝鸡市"},{"code":"6104","name":"咸阳市"},{"code":"6105","name":"渭南市"},{"code":"6106","name":"延安市"},{"code":"6107","name":"汉中市"},{"code":"6108","name":"榆林市"},{"code":"6109","name":"安康市"},{"code":"6110","name":"商洛市"}]},{"code":"62","name":"甘肃省","children":[{"code":"6201","name":"兰州市"},{"code":"6202","name":"嘉峪关市"},{"code":"6203","name":"金昌市"},{"code":"6204","name":"白银市"},{"code":"6205","name":"天水市"},{"code":"6206","name":"武威市"},{"code":"6207","name":"张掖市"},{"code":"6208","name":"平凉市"},{"code":"6209","name":"酒泉市"},{"code":"6210","name":"庆阳市"},{"code":"6211","name":"定西市"},{"code":"6212","name":"陇南市"},{"code":"6229","name":"临夏回族自治州"},{"code":"6230","name":"甘南藏族自治州"}]},{"code":"63","name":"青海省","children":[{"code":"6301","name":"西宁市"},{"code":"6302","name":"海东市"},{"code":"6322","name":"海北藏族自治州"},{"code":"6323","name":"黄南藏族自治州"},{"code":"6325","name":"海南藏族自治州"},{"code":"6326","name":"果洛藏族自治州"},{"code":"6327","name":"玉树藏族自治州"},{"code":"6328","name":"海西蒙古族藏族自治州"}]},{"code":"64","name":"宁夏回族自治区","children":[{"code":"6401","name":"银川市"},{"code":"6402","name":"石嘴山市"},{"code":"6403","name":"吴忠市"},{"code":"6404","name":"固原市"},{"code":"6405","name":"中卫市"}]},{"code":"65","name":"新疆维吾尔自治区","children":[{"code":"6501","name":"乌鲁木齐市"},{"code":"6502","name":"克拉玛依市"},{"code":"6504","name":"吐鲁番市"},{"code":"6505","name":"哈密市"},{"code":"6523","name":"昌吉回族自治州"},{"code":"6527","name":"博尔塔拉蒙古自治州"},{"code":"6528","name":"巴音郭楞蒙古自治州"},{"code":"6529","name":"阿克苏地区"},{"code":"6530","name":"克孜勒苏柯尔克孜自治州"},{"code":"6531","name":"喀什地区"},{"code":"6532","name":"和田地区"},{"code":"6540","name":"伊犁哈萨克自治州"},{"code":"6542","name":"塔城地区"},{"code":"6543","name":"阿勒泰地区"},{"code":"659001","name":"石河子市"},{"code":"659002","name":"阿拉尔市"},{"code":"659003","name":"图木舒克市"},{"code":"659004","name":"五家渠市"},{"code":"659005","name":"北屯市"},{"code":"659006","name":"铁门关市"},{"code":"659007","name":"双河市"},{"code":"659008","name":"可克达拉市"},{"code":"659009","name":"昆玉市"},{"code":"659010","name":"胡杨河市"},{"code":"659011","name":"新星市"},{"code":"659012","name":"白杨市"}]}]

/***/ }),

/***/ "c7iU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"titlebar"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"titlenav"},[_c('div',{staticClass:"navitem",on:{"click":function($event){return _vm.gotoHomePage()}}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Home")])]),_vm._v(" "),_c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoRegTiePage}},[_vm._v("百万铁人")])]),_vm._v(" "),_c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoClublist}},[_vm._v("俱乐部")])]),_vm._v(" "),_c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoRacelist}},[_vm._v("赛事")])]),_vm._v(" "),_c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoShoplist}},[_vm._v("装备")])]),_vm._v(" "),_c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoCourselist}},[_vm._v("课程")])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"navRegitem"},[(!_vm.isShowLoginBtn)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoMyPage}},[_vm._v("个人中心")]):_vm._e(),_vm._v(" "),(_vm.isShowLoginBtn)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.gotoRegPage}},[_vm._v("\n        登录/注册")]):_vm._e()]),_vm._v(" "),_vm._m(3)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleimg"},[_c('img',{attrs:{"src":__webpack_require__("G4DH"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoimg"},[_c('img',{attrs:{"src":__webpack_require__("sV85"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navitem"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("联系我们")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personbox"},[_c('img',{attrs:{"src":__webpack_require__("YsnE"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cmCH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type2hover.7fc6ee8.jpg";

/***/ }),

/***/ "eD7S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/bg1.b80b468.jpg";

/***/ }),

/***/ "elte":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/type3bg.2335def.jpg";

/***/ }),

/***/ "gMGb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/more1.52bdf23.png";

/***/ }),

/***/ "gMMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hM9b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/tieren2.f6e66af.jpg";

/***/ }),

/***/ "isE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_less_global_css__ = __webpack_require__("ORax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_less_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_less_global_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "shopdes",
  data: function data() {
    return {
      showpos2: false,
      shopitem: {},
      price2: 0,
      currentHoverId: null, // 当前悬停图片的 ID
      currentHoverId2: null, // 当前悬停图片的 ID
      showsku1box: false,
      showsku2box: false,
      sku1Text: "",
      sku2Text: "",
      chooseSku1Value: null,
      chooseSku2Value: null,
      showsku: {}
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_4__components_block_myhead__["a" /* default */]
  },
  computed: {

    // 对 skuList 中的 skuValue1 去重
    uniqueSku1List: function uniqueSku1List() {
      var seenValues = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.shopitem != null && this.shopitem.skuList != null) {
        return this.shopitem.skuList.filter(function (item) {
          var key = item.skuValue1;
          if (seenValues.has(key)) {
            return false;
          }
          seenValues.add(key);
          return true;
        });
      }
    },
    uniqueSku2List: function uniqueSku2List() {
      var _this = this;

      var seenValues = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (this.shopitem != null && this.shopitem.skuList != null) {
        // console.log("uniqueSku2List");
        return this.shopitem.skuList.filter(function (item) {
          if (_this.chooseSku1Value == item.skuValue1) {
            var key = item.skuValue2;
            if (seenValues.has(key)) {
              return false;
            }
            seenValues.add(key);
            return true;
          } else {
            return false;
          }
        });
      }
    }
  },
  methods: {
    GotoBuy: function GotoBuy() {
      // console.log(this.showsku);
      // console.log(this.showsku.id);
      this.token = localStorage.getItem("token");
      if (!this.token) {
        alert("请先登录");
        this.$router.push({
          name: "regPage"
        });
      } else {
        this.$router.push({
          name: "shopbuy",
          params: {
            id: this.shopitem.id,
            sku: this.showsku.id
          }
        });
      }
    },
    showSkuText: function showSkuText(id) {
      var _this2 = this;

      // console.log("showSkuText=" + id);
      this.shopitem.skuList.forEach(function (element) {
        if (element.id == id) {
          if (element.skuValue1.length > 0) {
            _this2.currentHoverId = id;
          }
        }
      });
    },

    // 鼠标移开时清空当前 ID
    hideSkuText: function hideSkuText() {
      this.currentHoverId = null;
    },
    showSku2Text: function showSku2Text(id) {
      var _this3 = this;

      // console.log("showSkuText=" + id);
      this.shopitem.skuList.forEach(function (element) {
        if (element.id == id) {
          if (element.skuValue1.length > 0) {
            _this3.currentHoverId2 = id;
          }
        }
      });
    },

    // 鼠标移开时清空当前 ID
    hideSku2Text: function hideSku2Text() {
      this.currentHoverId2 = null;
    },
    chooseSku1: function chooseSku1(id) {
      var _this4 = this;

      this.chooseSku2Value = null;
      this.shopitem.skuList.forEach(function (element) {
        if (element.id == id) {
          if (element.skuValue1 != _this4.chooseSku1Value) {
            _this4.chooseSku1Value = element.skuValue1;
            if (element.skuValue2.length > 0) {
              if (_this4.chooseSku2Value == null) {
                _this4.chooseSku2Value = element.skuValue2;
                _this4.showsku = element;
                _this4.price2 = element.price;
              }
            } else {
              _this4.showsku = element;
              _this4.price2 = element.price;
            }
          }
        }
      });
    },
    chooseSku2: function chooseSku2(id) {
      var _this5 = this;

      this.shopitem.skuList.forEach(function (element) {
        if (element.id == id) {
          if (element.skuValue2 != _this5.chooseSku2Value) {
            _this5.chooseSku2Value = element.skuValue2;
            _this5.showsku = element;
            _this5.price2 = element.price;
          }
        }
      });
    },
    CheckShopitemList: function CheckShopitemList() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this6.response = null;
                _this6.error = null;
                params = {
                  id: _this6.shopid
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttProd/SKU";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                  }
                });

              case 7:
                response = _context.sent;

                // 处理成功响应
                _this6.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response.code);
                if (_this6.response.code == 200) {
                  // console.log(this.response.data);
                  _this6.shopitem = _this6.response.data;
                  console.log(_this6.shopitem);
                  _this6.showsku = _this6.shopitem.skuList[0];
                  _this6.price2 = _this6.shopitem.skuList[0].price;
                  _this6.shopitem.skuList.forEach(function (element) {
                    if (element.skuValue1.length > 0) {
                      _this6.showsku1box = true;
                      if (_this6.chooseSku1Value == null) {
                        _this6.chooseSku1Value = element.skuValue1;
                      }
                      _this6.sku1Text = element.skuKey1;
                    } else {
                      _this6.showsku1box = false;
                    }
                    if (element.skuValue2.length > 0) {
                      _this6.showsku2box = true;
                      if (_this6.chooseSku2Value == null) {
                        _this6.chooseSku2Value = element.skuValue2;
                      }
                      _this6.sku2Text = element.skuKey2;
                    } else {
                      _this6.showsku2box = false;
                    }
                  });
                } else {}
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this6.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this6.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this6.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this6.error);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.shopid = this.$route.params.id;
    console.log(this.shopid);
    this.CheckShopitemList();
  },
  created: function created() {
    //  console.log(this.$route.params);
  }
});

/***/ }),

/***/ "j3WW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"shopbox"},_vm._l((_vm.brandList),function(item2){return _c('div',{key:item2.id,staticClass:"shoplist1"},[_c('div',{staticClass:"shoptitlebox"},[_c('img',{attrs:{"src":item2.brandLogo}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item2.brandName))])]),_vm._v(" "),_c('swiper',{ref:"mySwiper",refInFor:true,staticClass:"shopswiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.shopitemlist[item2.id]),function(item){return _c('swiper-slide',{key:item.id},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.gotoShopDes(item.id)}}},[_c('div',{staticClass:"swiperitemimg"},[_c('img',{attrs:{"src":item.prodImage}})]),_vm._v(" "),_c('div',{staticClass:"shopitemdes"},[_c('p',[_vm._v(_vm._s(item.prodName))]),_vm._v(" "),_c('p',{staticClass:"shopitemdesp"},[_vm._v(_vm._s(item.typeCodeCn))]),_vm._v(" "),_c('p',[_vm._v("￥"+_vm._s(item.price))])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-scrollbar",attrs:{"slot":"scrollbar"},slot:"scrollbar"})],2)],1)}),0),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jADk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jCJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racelist_vue__ = __webpack_require__("Lg/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_085072b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_racelist_vue__ = __webpack_require__("/2Gk");
function injectStyle (ssrContext) {
  __webpack_require__("F48L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-085072b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racelist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_085072b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_racelist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jNq+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/clue-2-click.4fbb83f.png";

/***/ }),

/***/ "k8gW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/clue-1-click.96efba4.png";

/***/ }),

/***/ "kGmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"shopitembox"},[_c('div',{staticClass:"topbox"},[_c('div',{staticClass:"leftbox"},[_c('img',{attrs:{"src":_vm.showsku.skuImage,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"rightbox"},[_c('div',{staticClass:"itemtitle"},[_c('p',[_vm._v(_vm._s(_vm.shopitem.prodName))]),_vm._v(" "),_c('p',{staticClass:"itemtype"},[_vm._v(_vm._s(_vm.shopitem.typeCodeCn))]),_vm._v(" "),_c('p',{staticClass:"itemprice"},[_vm._v("￥"+_vm._s(_vm.price2))]),_vm._v(" "),(_vm.showsku1box)?_c('p',{staticClass:"skutype1"},[_vm._v("选择"+_vm._s(_vm.sku1Text))]):_vm._e(),_vm._v(" "),(_vm.showsku1box)?_c('div',{staticClass:"allskubox"},_vm._l((this.uniqueSku1List),function(item2){return _c('div',{key:item2.id,staticClass:"skubox",class:{ choosebox: _vm.chooseSku1Value == item2.skuValue1 },on:{"click":function($event){return _vm.chooseSku1(item2.id)},"mouseover":function($event){return _vm.showSkuText(item2.id)},"mouseleave":function($event){return _vm.hideSkuText()}}},[_c('img',{attrs:{"src":item2.skuImage,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"skunamebox"},[_c('p',[_vm._v(_vm._s(item2.skuValue1))])])])}),0):_vm._e(),_vm._v(" "),(_vm.showsku2box)?_c('p',{staticClass:"skutype1"},[_vm._v("选择"+_vm._s(_vm.sku2Text))]):_vm._e(),_vm._v(" "),(_vm.showsku2box)?_c('div',{staticClass:"allskubox"},_vm._l((this.uniqueSku2List),function(item2){return _c('div',{key:item2.id,staticClass:"skubox skubox2",class:{ choosebox2: _vm.chooseSku2Value == item2.skuValue2 },on:{"click":function($event){return _vm.chooseSku2(item2.id)},"mouseover":function($event){return _vm.showSku2Text(item2.id)},"mouseleave":function($event){return _vm.hideSku2Text()}}},[_c('div',{staticClass:"skunamebox skunamebox2"},[_c('p',[_vm._v(_vm._s(item2.skuValue2))])])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"buyitem"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.GotoBuy()}}},[_c('span',[_vm._v("购买")])])])])]),_vm._v(" "),_c('div',{staticClass:"midbox"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"skudes",domProps:{"innerHTML":_vm._s(_vm.shopitem.prodContent)}})])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"midboxtitle"},[_c('p',[_vm._v("商品详情")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kswo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2830fa63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("SSAN");
function injectStyle (ssrContext) {
  __webpack_require__("9PZO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2830fa63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2830fa63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mrS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courselist_vue__ = __webpack_require__("GueC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee008f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courselist_vue__ = __webpack_require__("z0Kd");
function injectStyle (ssrContext) {
  __webpack_require__("6Ten")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ee008f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courselist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee008f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courselist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nGHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_json_countries_json__ = __webpack_require__("MtKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_json_Province_json__ = __webpack_require__("b3kF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_json_Province_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_json_Province_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ali_oss__ = __webpack_require__("/Z0X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ali_oss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ali_oss__);





var _name$data$components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = (_name$data$components = {
  name: "RegTiePage",
  data: function data() {
    var _ref;

    return _ref = {
      msg: "",
      response: null, // 存储服务器返回的数据
      error: null, // 存储请求错误信息
      userinfo: {},
      formData: {
        nickName: "", // 用户名（手机号或邮箱）
        userGender: "male",
        selectedYear: "2025", // 选中的年份
        selectedMonth: "01", // 选中的月份
        selectedDay: "1", // 选中的日期
        countryName: "中国", // 选中的国家
        countryId: "86",
        stationName: "北京", // 选中的省份
        stationId: "1",
        cityName: "北京", // 选中的城市
        cityId: "1",
        clubName: "动境俱乐部", // 选中的俱乐部
        clubId: "1",
        documentType: "id_card", // 选中的
        documentNumber: "", // 选中的
        documentNumber2: "" // 选中的
      },
      selectedAgreement: false, // 选中的
      selectedAgreement2: false, // 选中的
      isRegType: 0, //0 未注册1已注册待审核3审核通过
      years: [], // 动态生成的年份列表
      months: [
      // 固定的月份列表
      { value: "01", text: "1 月" }, { value: "02", text: "2 月" }, { value: "03", text: "3 月" }, { value: "04", text: "4 月" }, { value: "05", text: "5 月" }, { value: "06", text: "6 月" }, { value: "07", text: "7 月" }, { value: "08", text: "8 月" }, { value: "09", text: "9 月" }, { value: "10", text: "10 月" }, { value: "11", text: "11 月" }, { value: "12", text: "12 月" }],
      days: [], // 动态生成的日期列表
      CountryList: __WEBPACK_IMPORTED_MODULE_6__assets_json_countries_json___default.a, // 国家列表
      ProvinceList: __WEBPACK_IMPORTED_MODULE_7__assets_json_Province_json___default.a, // 省份列表
      CityList: [], // 城市列表
      Clubdata: [{
        id: "1",
        clubNumber: "10001",
        clubName: "动境俱乐部",
        clubContact: "联系人",
        userEmail: "aaates@gmail.com",
        userPhone: "13310012222",
        remark: null
      }, {
        id: "2",
        clubNumber: "10002",
        clubName: "澳大利亚俱乐部",
        clubContact: "联系人",
        userEmail: "aaates@gmail.com",
        userPhone: "13310012222",
        remark: null
      }, {
        id: "3",
        clubNumber: "10000",
        clubName: "无",
        clubContact: "联系人",
        userEmail: "aaates@gmail.com",
        userPhone: "13310012222",
        remark: null
      }],
      CardType: [{
        id: "id_card",
        cardType: "身份证"
      }, {
        id: "passport",
        cardType: "护照"
      }],
      ReviewStatus: {
        new_user: "新用户",
        awaiting_review: "已提交申请，待审核",
        fail_review: "审核失败",
        register: "认证铁人"
      },
      credentials: null, // 存储临时凭证
      uploadStatus: "", // 上传状态或结果提示
      selectedFile: null }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "response", null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "error", null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "isupimging", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "UPimageSrc", ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "isButton1Disabled", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "token", ""), _ref;
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_4__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_5__components_block_myhead__["a" /* default */]
  },
  watch: {
    // selectedAgreement: function() {
    //   this.AgreementDisabled = !this.selectedAgreement;
    // },
    // selectedAgreement2: function() {
    //   this.AgreementDisabled = !this.selectedAgreement2;
    // }
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
    isChinaSelected: function isChinaSelected() {
      // 判断是否选择了中国
      return this.formData.countryName === "中国";
    },
    AgreementDisabled: function AgreementDisabled() {
      // 动态计算 AgreementDisabled
      return this.selectedAgreement && this.selectedAgreement2;
    }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Index"
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: "mypage"
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: "Setpage"
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: "Rankpage"
      });
    },
    handleregbtn: function handleregbtn() {
      console.log("handleregbtn");
      this.sendloginPostRequest();
    },
    RegAgain: function RegAgain() {
      console.log("RegAgain");
      this.isRegType = 0;
    },
    CheckUserPostRequest: function CheckUserPostRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this.response = null;
                _this.error = null;
                url = " https://ttserver.aizhuotice.online/api/v1/userInfo";
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, {
                  headers: {
                    "Content-Type": "application/json",
                    token: _this.token
                  }
                });

              case 6:
                response = _context.sent;

                // 处理成功响应
                _this.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this.response);
                if (_this.response.code == 200) {
                  _this.userinfo = _this.response.data;
                  console.log(_this.userinfo);
                  console.log(_this.userinfo.status);
                  // console.log(this.userinfo.documentNumber);
                  // console.log(this.userinfo.documentNumber.length);

                  if (_this.userinfo.status == "new_user") {
                    _this.isRegType = 0;
                  }
                  if (_this.userinfo.status == "awaiting_review") {
                    _this.isRegType = 1;
                  }
                  if (_this.userinfo.status == "fail_review") {
                    _this.isRegType = 2;
                  }
                  if (_this.userinfo.status == "register") {
                    _this.isRegType = 3;
                  }
                }
                if (_this.response.code == 4011) {
                  // alert(this.response.message);
                  _this.token = "";
                  localStorage.setItem("token", "");
                  alert("请先登录");
                  _this.gotoHomePage();
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this.error);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    sendloginPostRequest: function sendloginPostRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!_this2.isButton1Disabled) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                // 禁用按钮
                _this2.isButton1Disabled = true;
                // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                // 验证用户输入

                if (!(!_this2.formData.nickName || !_this2.formData.userGender || !_this2.formData.selectedYear || !_this2.formData.selectedMonth || !_this2.formData.selectedDay || !_this2.formData.countryName || !_this2.formData.stationName || !_this2.formData.cityName || !_this2.formData.clubName || !_this2.formData.documentType || !_this2.formData.documentNumber || !_this2.UPimageSrc)) {
                  _context2.next = 9;
                  break;
                }

                _this2.error = "";
                return _context2.abrupt("return");

              case 9:
                if (!(_this2.formData.documentType == "id_card")) {
                  _context2.next = 13;
                  break;
                }

                if (!(_this2.formData.documentNumber.length != 18)) {
                  _context2.next = 13;
                  break;
                }

                alert("身份证号格式错误");
                return _context2.abrupt("return");

              case 13:
                _this2.formData.birthday = _this2.formData.selectedYear + "-" + _this2.formData.selectedMonth + "-" + _this2.formData.selectedDay;
                _this2.formData.imageUrl = _this2.UPimageSrc;
                _this2.formData.token = _this2.token;
                // 配置 POST 请求的 URL 和数据
                url = "https://ttserver.aizhuotice.online/api/v1/review/userInfo";

                console.log(_this2.formData);
                // 发起 POST 请求
                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(url, _this2.formData, {
                  headers: {
                    "Content-Type": "application/json",
                    token: _this2.token
                  }
                });

              case 20:
                response = _context2.sent;

                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this2.response);
                if (_this2.response.code == 200) {
                  alert("提交成功");
                  // localStorage.setItem('token', this.response.data.token);
                  _this2.gotoHomePage();
                }
                _context2.next = 29;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }

              case 29:
                _context2.prev = 29;

                // 无论成功或失败，都重新启用按钮
                _this2.isButton1Disabled = false;
                return _context2.finish(29);

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 26, 29, 32]]);
      }))();
    },

    handlebacklogin: function handlebacklogin() {
      console.log("handlebacklogin");
      //   this.showloginbox = true;
      //   this.showregbox = false;
    },
    updateDays: function updateDays() {
      // 根据年份和月份计算日期数量
      var year = parseInt(this.formData.selectedYear);
      var month = parseInt(this.formData.selectedMonth);
      // 使用 Date 对象计算某个月的最大天数
      var lastDayOfMonth = new Date(year, month, 0).getDate();
      // 更新日期列表
      this.days = [];
      for (var day = 1; day <= lastDayOfMonth; day++) {
        this.days.push(day);
      }
      //   console.log(this.days);
      // 如果选中的日期超出范围，则重置为最大日期
      if (this.formData.selectedDay > lastDayOfMonth) {
        this.formData.selectedDay = lastDayOfMonth;
      }
    },
    updataCountry: function updataCountry() {
      var _this3 = this;

      var selectedCountry = this.CountryList.find(function (country) {
        return country.chinese === _this3.formData.countryName;
      });
      if (selectedCountry) {
        var chinese = selectedCountry.chinese; // 获取中文名
        var code = selectedCountry.code; // 获取国家代码
        console.log("选中的国家:", chinese);
        console.log("国家代码:", code);
        this.formData.countryId = code;
      }
    },
    showProvince: function showProvince() {
      console.log(this.formData.countryName);
      return this.formData.countryName === "中国";
    },
    showCity: function showCity() {
      return this.showProvince && this.formData.stationName;
    },
    updateProvince: function updateProvince() {
      var _this4 = this;

      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.stationName);
      // console.log(this.ProvinceList[0].name);
      // console.log(this.ProvinceList[1].name);
      var code = this.findstationCodeByName(this.formData.stationName);
      console.log(code);
      this.formData.stationId = code;
      if (this.formData.stationName) {
        var stationName = this.ProvinceList.find(function (province) {
          return province.name === _this4.formData.stationName;
        });
        console.log(stationName);
        this.CityList = stationName ? stationName.children : [];
        this.formData.cityName = ""; // 清空城市选择
      } else {
        this.CityList = []; // 清空城市列表
        this.formData.cityName = ""; // 清空城市选择
      }
    },
    getProvinceName: function getProvinceName(code) {
      // 根据省份代码获取省份名称
      var province = this.ProvinceList.find(function (province) {
        return province.code === code;
      });
      return province ? province.name : "";
    },
    getCityName: function getCityName(code) {
      // 根据城市代码获取城市名称
      var city = this.CityList.find(function (city) {
        return city.code === code;
      });
      return city ? city.name : "";
    },
    findstationCodeByName: function findstationCodeByName(targetName) {
      // console.log(targetName);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.ProvinceList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.name === targetName) {
            return item.code; // 找到匹配项，直接返回 code
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null; // 如果找不到，返回 null
    },
    findCityCodeByName: function findCityCodeByName(data, targetName) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.name === targetName) {
            return item.code; // 找到匹配项，直接返回 code
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null; // 如果找不到，返回 null
    },
    updateCity: function updateCity() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.cityName);
      var code = this.findCityCodeByName(this.CityList, this.formData.cityName);
      console.log(code);
      this.formData.cityId = code;
    },
    updateClub: function updateClub() {
      var _this5 = this;

      console.log(this.formData.clubName);
      var selectedCountry = this.Clubdata.find(function (country) {
        return country.clubName === _this5.formData.clubName;
      });
      if (selectedCountry) {
        var chinese = selectedCountry.clubName; // 获取中文名
        var code = selectedCountry.id; // 获取国家代码
        console.log("选中的clue:", chinese);
        console.log("club代码:", code);
        this.formData.clubId = code;
      }
    },
    openFilePicker: function openFilePicker() {
      if (this.isupimging) {
        return;
      }
      this.$refs.fileInput.click(); // 触发隐藏的文件输入框
    },
    testupfile: function testupfile() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var client, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (_this6.selectedFile) {
                  _context3.next = 4;
                  break;
                }

                _this6.message = "请先选择一个文件！";
                return _context3.abrupt("return");

              case 4:
                _this6.isupimging = true;
                client = new __WEBPACK_IMPORTED_MODULE_9_ali_oss___default.a({
                  bucket: "tieren3", // 替换为你的 OSS Bucket 名称
                  region: "oss-cn-beijing", // 替换为你的 OSS 区域
                  accessKeyId: "LTAI5tG9Dtp6KecASCY1Mhri",
                  accessKeySecret: "oo7N9qVPoP6pil4hzDMmPcdD1LrBB9"
                });
                // 执行文件上传

                _context3.next = 8;
                return client.put(_this6.selectedFile.name, _this6.selectedFile);

              case 8:
                result = _context3.sent;

                console.log(result);
                _this6.uploadStatus = "文件上传成功！";
                _this6.showupimg(result.url);
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](0);

                _this6.uploadStatus = "\u4E0A\u4F20\u5931\u8D25: " + _context3.t0.message;
                console.error(_context3.t0);

              case 18:
                _context3.prev = 18;

                _this6.isupimging = false;
                return _context3.finish(18);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 14, 18, 21]]);
      }))();
    },
    showupimg: function showupimg(url) {
      console.log(url);
      this.UPimageSrc = url;
    },
    reginput2sendbtn: function reginput2sendbtn() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var file, client, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                // 确保文件存在
                file = _this7.$refs.fileInput.files[0];

                if (file) {
                  _context4.next = 5;
                  break;
                }

                _this7.uploadStatus = "请选择一个文件！";
                return _context4.abrupt("return");

              case 5:
                if (!_this7.isCredentialsExpired(_this7.credentials)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 8;
                return _this7.fetchStsToken();

              case 8:
                _this7.credentials = _context4.sent;

              case 9:
                //         AccessKey ID
                // LTAI5tG9Dtp6KecASCY1Mhri
                // AccessKey Secret
                // oo7N9qVPoP6pil4hzDMmPcdD1LrBB9
                // 初始化 OSS 客户端
                client = new __WEBPACK_IMPORTED_MODULE_9_ali_oss___default.a({
                  bucket: "userFeedback", // 替换为你的 OSS Bucket 名称
                  region: "oss-cn-hangzhou", // 替换为你的 OSS 区域
                  accessKeyId: _this7.credentials.AccessKeyId,
                  accessKeySecret: _this7.credentials.AccessKeySecret,
                  stsToken: _this7.credentials.SecurityToken
                });
                // 执行文件上传

                _context4.next = 12;
                return client.put(file.name, file);

              case 12:
                result = _context4.sent;

                console.log(result);
                _this7.uploadStatus = "文件上传成功！";
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](0);

                _this7.uploadStatus = "\u4E0A\u4F20\u5931\u8D25: " + _context4.t0.message;
                console.error(_context4.t0);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 17]]);
      }))();
    },

    /**
     * 获取临时 STS 凭证
     */
    fetchStsToken: function fetchStsToken() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetch("https://ttserver.aizhuotice.online/manage/v1/sts", {
                  method: "GET"
                });

              case 2:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 5;
                  break;
                }

                throw new Error("\u83B7\u53D6STS\u4EE4\u724C\u5931\u8D25: " + response.status + " " + response.statusText);

              case 5:
                _context5.next = 7;
                return response.json();

              case 7:
                return _context5.abrupt("return", _context5.sent);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },

    /**
     * 判断临时凭证是否到期
     */
    isCredentialsExpired: function isCredentialsExpired(credentials) {
      if (!credentials) {
        return true;
      }
      var expireDate = new Date(credentials.Expiration);
      var now = new Date();
      // 如果有效期不足一分钟，视为过期
      return expireDate.getTime() - now.getTime() <= 60000;
    },

    // 监听文件选择事件
    handleFileChange: function handleFileChange(event) {
      // 获取用户选择的文件
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        console.log("已选择文件:", this.selectedFile.name);
        this.testupfile();
      } else {
        console.log("未选择文件");
      }
    },

    // 上传文件
    uploadFile: function uploadFile() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var formData, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this9.selectedFile) {
                  _context6.next = 3;
                  break;
                }

                alert("请选择一个文件！");
                return _context6.abrupt("return");

              case 3:
                // 创建FormData对象，用于存储文件数据
                formData = new FormData();

                formData.append("file", _this9.selectedFile); // 'file'是字段名，需与后端保持一致
                formData.append("token", "1234567890");
                _context6.prev = 6;
                _context6.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("https://ttserver.aizhuotice.online/manage/v1/sts", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data" // 设置请求头类型为表单数据
                  }
                });

              case 9:
                response = _context6.sent;

                console.log("文件上传成功", response.data);
                alert("文件上传成功！");
                _context6.next = 18;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](6);

                console.error("文件上传失败", _context6.t0);
                alert("文件上传失败，请稍后再试！");

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[6, 14]]);
      }))();
    },
    GetstsToken: function GetstsToken() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url, postData, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                // 清空之前的响应和错误信息
                _this10.response = null;
                _this10.error = null;
                // 验证用户输入
                // 配置 POST 请求的 URL 和数据
                url = " https://ttserver.aizhuotice.online/manage/v1/sts";
                postData = {
                  token: _this10.token
                };
                // 发起 POST 请求

                _context7.next = 7;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(url, postData);

              case 7:
                response = _context7.sent;

                // 处理成功响应
                _this10.response = response.data; // 将返回的数据存储到组件状态
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](0);

                // 处理请求错误
                if (_context7.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this10.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context7.t0.response.status + " - " + _context7.t0.response.statusText;
                } else if (_context7.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this10.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this10.error = "\u8BF7\u6C42\u5931\u8D25: " + _context7.t0.message;
                }

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 11]]);
      }))();
    }
  }
}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_name$data$components, "watch", {
  countryName: function countryName(newVal) {
    // 当用户切换国家时，如果不是中国，清空省份和城市选择
    if (!this.isChinaSelected) {
      this.formData.stationName = "";
      this.formData.cityName = "";
      this.CityList = [];
    }
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_name$data$components, "mounted", function mounted() {
  this.$nextTick(function () {
    window.scrollTo(0, 0); // 确保 DOM 渲染完成后滚动到顶部
    console.log("滚动到顶部");
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_name$data$components, "created", function created() {
  // 初始化年份列表
  var currentYear = new Date().getFullYear();
  for (var year = currentYear; year >= 1900; year--) {
    this.years.push(year);
  }
  // 默认选中当前年份和月份
  this.formData.selectedYear = currentYear;
  this.formData.selectedMonth = "01";
  // 初始化日期列表
  this.updateDays();
  this.token = localStorage.getItem("token");
  if (!this.token) {
    alert("请先登录");
    this.gotoHomePage();
  } else {
    this.CheckUserPostRequest();
  }
}), _name$data$components);

/***/ }),

/***/ "oSuS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("Hpn/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pgUL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/haed1.f04a84e.jpg";

/***/ }),

/***/ "pt6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_vue__ = __webpack_require__("2EVb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3eb294_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shop_vue__ = __webpack_require__("j3WW");
function injectStyle (ssrContext) {
  __webpack_require__("rdO+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f3eb294"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3eb294_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r4Jm":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "rRUX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/bg2.a8e2bb6.jpg";

/***/ }),

/***/ "rdO+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s9wN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clubdes_vue__ = __webpack_require__("16gr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256cc434_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clubdes_vue__ = __webpack_require__("KtIe");
function injectStyle (ssrContext) {
  __webpack_require__("NfIJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-256cc434"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clubdes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256cc434_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clubdes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sV85":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/logo3.0035d35.png";

/***/ }),

/***/ "tKq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"homebox"},[_c('div',{staticClass:"racetitle"},[_c('img',{attrs:{"src":__webpack_require__("ElVu"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"racemask"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.racedes.raceName))])]),_vm._v(" "),_c('div',{staticClass:"racetype"},[_c('div',{staticClass:"typebg"},[_c('img',{attrs:{"src":__webpack_require__("AdJh"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"type1box"},[_vm._v("\n          "+_vm._s(_vm.racedes.countryName)+"-"+_vm._s(_vm.racedes.cityName)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"type2box"},[_vm._v(_vm._s(_vm.racedes.racetime))]),_vm._v(" "),_c('p',{staticClass:"type3box"},[_vm._v(_vm._s(_vm.racedes.racePeopleNumber))]),_vm._v(" "),_c('p',{staticClass:"type4box"},[_vm._v(_vm._s(_vm.racedes.days))])])]),_vm._v(" "),_c('div',{staticClass:"topdes"},[_c('div',{staticClass:"leftdes"},[_c('p',{staticClass:"leftdes-title"},[_vm._v(_vm._s(_vm.racedes.raceName))]),_vm._v(" "),_c('p',{staticClass:"leftdes-content",domProps:{"innerHTML":_vm._s(_vm.racedes.raceContent)}}),_vm._v(" "),_c('div',{staticClass:"leftdes-img"},[_c('img',{attrs:{"src":_vm.racedes.raceImage,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"rightdes"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showregbox),expression:"!showregbox"}],staticClass:"bigregbox"},[_c('div',{staticClass:"regbox1"},[_c('p',{staticClass:"regbox-title"},[_vm._v("姓名")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userFullName),expression:"formData.userFullName"}],staticClass:"regbox-input",attrs:{"type":"text","placeholder":"中文姓名"},domProps:{"value":(_vm.formData.userFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userFullName", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.englishName),expression:"formData.englishName"}],staticClass:"regbox-input2",attrs:{"type":"text","placeholder":"姓名拼音"},domProps:{"value":(_vm.formData.englishName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "englishName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"regbox2"},[_c('p',{staticClass:"regbox-title"},[_vm._v("邮箱")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userEmail),expression:"formData.userEmail"}],staticClass:"regbox-inputall",attrs:{"type":"text","placeholder":"输入您的电子邮箱"},domProps:{"value":(_vm.formData.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userEmail", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"regbox3"},[_c('p',{staticClass:"regbox-title"},[_vm._v("手机号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userPhone),expression:"formData.userPhone"}],staticClass:"regbox-inputall",attrs:{"type":"text","placeholder":"输入您的手机号码"},domProps:{"value":(_vm.formData.userPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userPhone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"regbox5"},[_c('button',{staticClass:"regbox-button",on:{"click":_vm.handleregbtn}},[_vm._v("提交")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showregbox),expression:"showregbox"}],staticClass:"bigregbox2"},[_c('div',{staticClass:"packbox"},[_c('p',{staticClass:"packbox-title"},[_vm._v("套餐选择")]),_vm._v(" "),_c('div',{staticClass:"packlist"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOption),expression:"selectedOption"}],staticClass:"regbox-select",attrs:{"id":"my-select"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedOption=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onSelectChange]}},_vm._l((_vm.racedes.packageList),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n                  "+_vm._s(option.packageName)+"\n                ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"packdesbox",domProps:{"innerHTML":_vm._s(_vm.packdes)}}),_vm._v(" "),_c('div',{staticClass:"packpricebox"},[_vm._v("￥"+_vm._s(_vm.packprice))]),_vm._v(" "),_c('div',{staticClass:"buypackbtn",on:{"click":_vm.handlebuybtn}},[_c('a',{attrs:{"href":"#"}},[_vm._v("购买此套餐")])])])])])]),_vm._v(" "),_c('div',{staticClass:"middes"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox1tripPlan),expression:"showracebox1tripPlan"}],staticClass:"racetype1box",style:(_vm.showtype1 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype1),expression:"!showtype1"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType1}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key1))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype1),expression:"showtype1"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType1}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key1))])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype1),expression:"showtype1"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.value1)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox2packageIntroduction),expression:"showracebox2packageIntroduction"}],staticClass:"racetype1box",style:(_vm.showtype2 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype2),expression:"!showtype2"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType2}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key2))])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype2),expression:"showtype2"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType2}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key2))])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype2),expression:"showtype2"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.value2)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox3packageContent),expression:"showracebox3packageContent"}],staticClass:"racetype1box",style:(_vm.showtype3 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype3),expression:"!showtype3"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType3}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key3))])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype3),expression:"showtype3"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType3}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key3))])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype3),expression:"showtype3"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.value3)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox4priceDetails),expression:"showracebox4priceDetails"}],staticClass:"racetype1box",style:(_vm.showtype4 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype4),expression:"!showtype4"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType4}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key4))])]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype4),expression:"showtype4"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType4}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key4))])]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype4),expression:"showtype4"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.value4)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox5accommodateDetails),expression:"showracebox5accommodateDetails"}],staticClass:"racetype1box",style:(_vm.showtype5 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype5),expression:"!showtype5"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType5}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key5))])]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype5),expression:"showtype5"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType5}},[_c('p',[_vm._v(_vm._s(_vm.racedes.key5))])]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype5),expression:"showtype5"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.value5)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showracebox6publicTransportation),expression:"showracebox6publicTransportation"}],staticClass:"racetype1box",style:(_vm.showtype6 ? { border: '1px solid #4a3aff' } : {})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showtype6),expression:"!showtype6"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType6}},[_c('p',[_vm._v("公共交通")])]),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype6),expression:"showtype6"}],staticClass:"racetype1image"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.ChageceType6}},[_c('p',[_vm._v("公共交通")])]),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtype6),expression:"showtype6"}],staticClass:"racetype1content",domProps:{"innerHTML":_vm._s(_vm.racedes.publicTransportation)}})])])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(255, 255, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-1"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(74, 58, 255)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"racetypearrow",staticStyle:{"background-color":"rgb(74, 58, 255)"}},[_c('div',{staticClass:"accordion-arrow-wrapper---brix accordion-arrow-wrapper---brix-2"},[_c('div',{staticClass:"arrow-line---brix _2---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}}),_vm._v(" "),_c('div',{staticClass:"arrow-line---brix _1---brix",staticStyle:{"background-color":"rgb(255, 255, 255)"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tZwI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u/hN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/matchbg2.7dbd843.jpg";

/***/ }),

/***/ "uS1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racedes_vue__ = __webpack_require__("xyYT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_385ecc4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_racedes_vue__ = __webpack_require__("tKq3");
function injectStyle (ssrContext) {
  __webpack_require__("oSuS")
  __webpack_require__("VCAi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-385ecc4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_racedes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_385ecc4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_racedes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vY9p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"hometiebox"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"regbox"},[_c('div',{staticClass:"regtextbox"},[_vm._v("登记注册铁人")]),_vm._v(" "),(_vm.isRegType == 0)?_c('div',{staticClass:"regitem2"},[_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("\n            姓             名\n          ")]),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_c('div',{staticClass:"reginput1icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.nickName),expression:"formData.nickName"}],attrs:{"type":"text","placeholder":"请输入姓名"},domProps:{"value":(_vm.formData.nickName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "nickName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("\n            性             别\n          ")]),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_c('div',{staticClass:"reginput1icon"}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userGender),expression:"formData.userGender"}],staticClass:"sexbox",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "userGender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"male"}},[_vm._v("男")]),_vm._v(" "),_c('option',{attrs:{"value":"female"}},[_vm._v("女")])])])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("出  生  日  期")]),_vm._v(" "),_c('div',{staticClass:"reginputboxyear"},[_c('p',[_vm._v("年")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.selectedYear),expression:"formData.selectedYear"}],attrs:{"id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "selectedYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateDays]}},_vm._l((_vm.years),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v("\n                "+_vm._s(year)+"\n              ")])}),0),_vm._v(" "),_c('p',[_vm._v("月")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.selectedMonth),expression:"formData.selectedMonth"}],attrs:{"id":"month"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "selectedMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateDays]}},_vm._l((_vm.months),function(month){return _c('option',{key:month.value,domProps:{"value":month.value}},[_vm._v("\n                "+_vm._s(month.text)+"\n              ")])}),0),_vm._v(" "),_c('p',[_vm._v("日")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.selectedDay),expression:"formData.selectedDay"}],attrs:{"id":"day"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "selectedDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.days),function(day){return _c('option',{key:day,domProps:{"value":day}},[_vm._v("\n                "+_vm._s(day)+"\n              ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("国  籍 /地  区")]),_vm._v(" "),_c('div',{staticClass:"reginputboxyear"},[_c('p',{staticStyle:{"width":"4vw"}},[_vm._v("国家")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.countryName),expression:"formData.countryName"}],attrs:{"id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "countryName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updataCountry]}},_vm._l((_vm.CountryList),function(country){return _c('option',{key:country.abbr,domProps:{"value":country.chinese}},[_vm._v("\n                "+_vm._s(country.chinese)+" ("+_vm._s(country.english)+")\n              ")])}),0),_vm._v(" "),(_vm.isChinaSelected)?_c('p',[_vm._v("省")]):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.stationName),expression:"formData.stationName"}],attrs:{"id":"Province"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "stationName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateProvince]}},_vm._l((_vm.ProvinceList),function(province){return _c('option',{key:province.name,domProps:{"value":province.name}},[_vm._v("\n                "+_vm._s(province.name)+"\n              ")])}),0):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('p',[_vm._v("市")]):_vm._e(),_vm._v(" "),(_vm.isChinaSelected)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.cityName),expression:"formData.cityName"}],attrs:{"id":"City"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "cityName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateCity]}},_vm._l((_vm.CityList),function(city){return _c('option',{key:city.name,domProps:{"value":city.name}},[_vm._v("\n                "+_vm._s(city.name)+"\n              ")])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("所 属 俱 乐 部")]),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_c('div',{staticClass:"reginput1icon"}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.clubName),expression:"formData.clubName"}],staticClass:"sexbox",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "clubName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateClub]}},_vm._l((_vm.Clubdata),function(club){return _c('option',{key:club.id,domProps:{"value":club.clubName}},[_vm._v("\n                "+_vm._s(club.clubName)+"\n              ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("证  件  类  型")]),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_c('div',{staticClass:"reginput1icon"}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.documentType),expression:"formData.documentType"}],staticClass:"sexbox",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "documentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"id_card"}},[_vm._v("身份证")]),_vm._v(" "),_c('option',{attrs:{"value":"passport"}},[_vm._v("护照")])])])]),_vm._v(" "),_c('div',{staticClass:"reginput"},[_c('p',[_vm._v("证  件  号  码")]),_vm._v(" "),_c('div',{staticClass:"reginputbox"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.documentNumber),expression:"formData.documentNumber"}],attrs:{"type":"text","placeholder":"请输入证件号"},domProps:{"value":(_vm.formData.documentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "documentNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"reginput reginputupimgbox"},[_c('p',[_vm._v("完赛证明上传")]),_vm._v(" "),_c('div',{staticClass:"reginputbox reginput2"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.documentNumber2),expression:"formData.documentNumber2"}],attrs:{"type":"text","placeholder":"上传任一场铁人三项比赛完赛证明","disabled":"","value":"上传任一场铁人三项比赛完赛证明"},domProps:{"value":(_vm.formData.documentNumber2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "documentNumber2", $event.target.value)}}}),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file"},on:{"change":_vm.handleFileChange}}),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.isupimging},on:{"click":_vm.openFilePicker}},[_vm._v("\n              "+_vm._s(_vm.isupimging ? "上传中..." : "上传"))]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"regupimgdone"},[_c('img',{attrs:{"id":"upimgdoneurl","src":_vm.UPimageSrc,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"regfiletitle"},[_vm._v("隐私与协议")]),_vm._v(" "),_c('div',{staticClass:"regfiletext1"},[_vm._v("用户协议勾选（必选）：")]),_vm._v(" "),_c('div',{staticClass:"regfiletext2"},[_c('label',{staticStyle:{"display":"flex","align-items":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAgreement),expression:"selectedAgreement"}],staticClass:"regfilecheckbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedAgreement)?_vm._i(_vm.selectedAgreement,null)>-1:(_vm.selectedAgreement)},on:{"change":function($event){var $$a=_vm.selectedAgreement,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAgreement=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAgreement=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedAgreement=$$c}}}}),_vm._v("\n            “我已阅读并同意《用户服务协议》及《隐私保护政策》，并授权平台按协议处理我的信息。”\n          ")])]),_vm._v(" "),_c('div',{staticClass:"regfiletext2"},[_c('label',{staticStyle:{"display":"flex","align-items":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAgreement2),expression:"selectedAgreement2"}],staticClass:"regfilecheckbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedAgreement2)?_vm._i(_vm.selectedAgreement2,null)>-1:(_vm.selectedAgreement2)},on:{"change":function($event){var $$a=_vm.selectedAgreement2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAgreement2=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAgreement2=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedAgreement2=$$c}}}}),_vm._v("\n            “我承诺所提交的所有信息及证明文件真实、完整，并同意平台核查。如存在虚假，自愿承担相应法律责任。”\n          ")])]),_vm._v(" "),_c('div',{staticClass:"regbtn",class:[
            { disabled: _vm.isButton1Disabled },
            { disabledAgreement: !_vm.AgreementDisabled } ],on:{"click":_vm.handleregbtn}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.isButton1Disabled ? "提交中..." : "提交"))])])]):_vm._e(),_vm._v(" "),(_vm.isRegType == 1)?_c('div',{staticClass:"regitem3"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"reginfo"},[_c('p',[_vm._v("姓名："+_vm._s(_vm.userinfo.nickName))]),_vm._v(" "),(_vm.userinfo.userGender == 'male')?_c('p',[_vm._v("性别：男")]):_vm._e(),_vm._v(" "),(_vm.userinfo.userGender == 'female')?_c('p',[_vm._v("性别：女")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("出生日期："+_vm._s(_vm.userinfo.birthday))]),_vm._v(" "),_c('p',[_vm._v("国籍/地区："+_vm._s(_vm.userinfo.countryName))]),_vm._v(" "),_c('p',[_vm._v("所属俱乐部："+_vm._s(_vm.userinfo.clubName))]),_vm._v(" "),(_vm.userinfo.documentType == 'id_card')?_c('p',[_vm._v("证件类型：身份证")]):_vm._e(),_vm._v(" "),(_vm.userinfo.documentType == 'passport')?_c('p',[_vm._v("证件类型：护照")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("证件号码："+_vm._s(_vm.userinfo.documentNumber))])])]):_vm._e(),_vm._v(" "),(_vm.isRegType == 2)?_c('div',{staticClass:"regitem3"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"reginfo"},[_c('p',[_vm._v("姓名："+_vm._s(_vm.userinfo.nickName))]),_vm._v(" "),(_vm.userinfo.userGender == 'male')?_c('p',[_vm._v("性别：男")]):_vm._e(),_vm._v(" "),(_vm.userinfo.userGender == 'female')?_c('p',[_vm._v("性别：女")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("出生日期："+_vm._s(_vm.userinfo.birthday))]),_vm._v(" "),_c('p',[_vm._v("国籍/地区："+_vm._s(_vm.userinfo.countryName))]),_vm._v(" "),_c('p',[_vm._v("所属俱乐部："+_vm._s(_vm.userinfo.clubName))]),_vm._v(" "),(_vm.userinfo.documentType == 'id_card')?_c('p',[_vm._v("证件类型：身份证")]):_vm._e(),_vm._v(" "),(_vm.userinfo.documentType == 'passport')?_c('p',[_vm._v("证件类型：护照")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("证件号码："+_vm._s(_vm.userinfo.documentNumber))])]),_vm._v(" "),_c('div',{staticClass:"regbtn",on:{"click":_vm.RegAgain}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("重新提交")])])]):_vm._e(),_vm._v(" "),(_vm.isRegType == 3)?_c('div',{staticClass:"regitem3"},[_c('div',{staticClass:"regtitle"},[_c('p',[_vm._v("已通过审核")]),_vm._v(" "),_c('p',[_vm._v("认证铁人编号："+_vm._s(_vm.userinfo.ttNumber))])]),_vm._v(" "),_c('div',{staticClass:"reginfo"},[_c('p',[_vm._v("姓名："+_vm._s(_vm.userinfo.nickName))]),_vm._v(" "),(_vm.userinfo.userGender == 'male')?_c('p',[_vm._v("性别：男")]):_vm._e(),_vm._v(" "),(_vm.userinfo.userGender == 'female')?_c('p',[_vm._v("性别：女")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("出生日期："+_vm._s(_vm.userinfo.birthday))]),_vm._v(" "),_c('p',[_vm._v("国籍/地区："+_vm._s(_vm.userinfo.countryName))]),_vm._v(" "),_c('p',[_vm._v("所属俱乐部："+_vm._s(_vm.userinfo.clubName))]),_vm._v(" "),(_vm.userinfo.documentType == 'id_card')?_c('p',[_vm._v("证件类型：身份证")]):_vm._e(),_vm._v(" "),(_vm.userinfo.documentType == 'passport')?_c('p',[_vm._v("证件类型：护照")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("证件号码："+_vm._s(_vm.userinfo.documentNumber))])])]):_vm._e()])]),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hometieboximg"},[_c('img',{attrs:{"src":__webpack_require__("rRUX"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("1sot"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reginput1icon"},[_c('img',{attrs:{"src":__webpack_require__("1sot"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regupimg"},[_c('img',{attrs:{"src":__webpack_require__("JMHQ"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regtitle"},[_c('p',[_vm._v("已提交申请，待审核")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regtitle"},[_c('p',[_vm._v("审核失败，请重新提交")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xQRn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xWh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xbwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopbuy_vue__ = __webpack_require__("NJFc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38fc5cfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopbuy_vue__ = __webpack_require__("8zuc");
function injectStyle (ssrContext) {
  __webpack_require__("yzwe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38fc5cfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopbuy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38fc5cfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopbuy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xxP+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xyYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_block_footer__ = __webpack_require__("VIIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__ = __webpack_require__("FN+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "racedes",
  data: function data() {
    return {
      showregbox: true,
      showtype1: false,
      showtype2: false,
      showtype3: false,
      showtype4: false,
      showtype5: false,
      showtype6: false,
      showtype7: false,
      raceid: 0,
      racedes: {},
      selectedOption: "", // 当前选中的值
      packdes: "",
      packprice: "",

      formData: {
        userFullName: "", // 用户名（手机号或邮箱）
        englishName: "", // 用户名（手机号或邮箱）
        userEmail: "", // 用户名（手机号或邮箱）
        userPhone: "" // 用户名（手机号或邮箱）
      },
      raceList: [],
      showracebox1tripPlan: true,
      showracebox2packageIntroduction: false,
      showracebox3packageContent: false,
      showracebox4priceDetails: false,
      showracebox5accommodateDetails: false,
      showracebox6publicTransportation: false
    };
  },

  components: {
    footerBlock: __WEBPACK_IMPORTED_MODULE_2__components_block_footer__["a" /* default */],
    myheadBlock: __WEBPACK_IMPORTED_MODULE_3__components_block_myhead__["a" /* default */]
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Home"
      });
    },
    ChageceType1: function ChageceType1() {
      this.showtype1 = !this.showtype1;
    },
    ChageceType2: function ChageceType2() {
      this.showtype2 = !this.showtype2;
    },
    ChageceType3: function ChageceType3() {
      this.showtype3 = !this.showtype3;
    },
    ChageceType4: function ChageceType4() {
      this.showtype4 = !this.showtype4;
    },
    ChageceType5: function ChageceType5() {
      this.showtype5 = !this.showtype5;
    },
    ChageceType6: function ChageceType6() {
      this.showtype6 = !this.showtype6;
    },
    ChageceType7: function ChageceType7() {
      this.showtype7 = !this.showtype7;
    },

    handleregbtn: function handleregbtn() {
      console.log("handleregbtn");
      this.sendloginPostRequest();
    },
    handlebuybtn: function handlebuybtn() {
      console.log("handlebuybtn");
    },

    onSelectChange: function onSelectChange() {
      var _this = this;

      console.log("你选择了：", this.selectedOption);
      var packageItem = this.racedes.packageList.find(function (item) {
        return item.id === _this.selectedOption;
      });

      this.packdes = packageItem.packageContent;
      this.packprice = packageItem.packagePrice;
    },
    sendloginPostRequest: function sendloginPostRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // if (this.isButton1Disabled) return;
                // // 禁用按钮
                // this.isButton1Disabled = true;
                // // 清空之前的响应和错误信息
                _this2.response = null;
                _this2.error = null;
                // 验证用户输入

                if (!(!_this2.formData.userFullName || !_this2.formData.englishName || !_this2.formData.userEmail || !_this2.formData.userPhone)) {
                  _context.next = 6;
                  break;
                }

                _this2.error = "";
                return _context.abrupt("return");

              case 6:
                _this2.formData.raceId = _this2.raceid;

                // 配置 POST 请求的 URL 和数据
                url = "https://ttserver.aizhuotice.online/api/v1/save/ttMessageBoard";

                console.log(_this2.formData);
                // 发起 POST 请求
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, _this2.formData, {
                  headers: {
                    "Content-Type": "application/json",
                    token: _this2.token
                  }
                });

              case 11:
                response = _context.sent;

                // 处理成功响应
                _this2.response = response.data; // 将返回的数据存储到组件状态
                console.log(_this2.response);
                if (_this2.response.code == 200) {
                  alert("提交成功");
                }
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this2.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this2.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this2.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }

              case 20:
                _context.prev = 20;

                // 无论成功或失败，都重新启用按钮
                _this2.isButton1Disabled = false;
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 17, 20, 23]]);
      }))();
    },
    GetRaceDes: function GetRaceDes() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, url, response, isoDateString, dateObject, packageItem;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // 清空之前的响应和错误信息
                _this3.response = null;
                _this3.error = null;
                params = {
                  id: _this3.raceid
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfo";
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context2.sent;


                // 处理成功响应
                _this3.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response);
                if (_this3.response.code == 200) {
                  // console.log(this.response.data);
                  _this3.racedes = _this3.response.data;
                  // console.log(this.racedes);
                  isoDateString = _this3.racedes.raceDate.replace(" ", "T");
                  dateObject = new Date(isoDateString);
                  // console.log(dateObject.getMonth());

                  _this3.racedes.racetime = dateObject.getFullYear() + "年" + (dateObject.getMonth() + 1) + "月" + dateObject.getDate() + "日";
                  packageItem = _this3.racedes.packageList[0];


                  if (_this3.racedes.value1.length < 30) {
                    _this3.showracebox1tripPlan = false;
                  } else {
                    _this3.showracebox1tripPlan = true;
                  }

                  if (_this3.racedes.value2.length < 30) {
                    _this3.showracebox2packageIntroduction = false;
                  } else {
                    _this3.showracebox2packageIntroduction = true;
                  }

                  console.log(_this3.racedes.value3.length);
                  if (_this3.racedes.value3.length < 30) {
                    _this3.showracebox3packageContent = false;
                  } else {
                    _this3.showracebox3packageContent = true;
                  }
                  if (_this3.racedes.value4.length < 30) {
                    _this3.showracebox4priceDetails = false;
                  } else {
                    _this3.showracebox4priceDetails = true;
                  }

                  if (_this3.racedes.value5.length < 30) {
                    _this3.showracebox5accommodateDetails = false;
                  } else {
                    _this3.showracebox5accommodateDetails = true;
                  }

                  // if (this.racedes.publicTransportation.length<30) {
                  //   this.showracebox6publicTransportation = false;
                  // }else{
                  //   this.showracebox6publicTransportation = true;
                  // }

                  _this3.racedes.raceImage = "~assets/images/race/raceitem2.jpg";
                  _this3.racedes.imageList.forEach(function (element3) {
                    _this3.racedes.raceImage = element3.imageUrl;
                  });

                  _this3.packdes = packageItem.packageContent;
                  _this3.packprice = packageItem.packagePrice;
                  _this3.selectedOption = packageItem.id;
                } else {
                  console.log(_this3.response.code);
                }
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                // 处理请求错误
                if (_context2.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this3.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context2.t0.response.status + " - " + _context2.t0.response.statusText;
                } else if (_context2.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this3.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this3.error = "\u8BF7\u6C42\u5931\u8D25: " + _context2.t0.message;
                }
                console.log(_this3.error);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    },
    GetRaceList: function GetRaceList() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params, url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                // 清空之前的响应和错误信息
                _this4.response = null;
                _this4.error = null;
                params = {
                  page: 1,
                  size: 10
                };
                url = "https://ttserver.aizhuotice.online/api/v1/ttRaceInfoDetails/page";
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json"
                    // token: this.token,
                  }
                });

              case 7:
                response = _context3.sent;


                // 处理成功响应
                _this4.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response);
                if (_this4.response.code == 200) {
                  // console.log(this.response.data);
                  _this4.raceList = _this4.response.data.data;
                  // console.log("this.raceList");
                  // console.log(this.raceList);
                  // console.log(this.raceList.length);
                } else {}
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);

                // 处理请求错误
                if (_context3.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this4.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context3.t0.response.status + " - " + _context3.t0.response.statusText;
                } else if (_context3.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this4.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this4.error = "\u8BF7\u6C42\u5931\u8D25: " + _context3.t0.message;
                }
                console.log(_this4.error);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 12]]);
      }))();
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  created: function created() {
    this.raceid = this.$route.params.id;
    // console.log(this.$route.params);
    console.log(this.raceid);
    if (this.raceid == null) {
      this.raceid = 1;
    }
    // console.log(this.raceid);
    this.GetRaceDes();
    this.GetRaceList();
  }
});

/***/ }),

/***/ "yRbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyFooter",
  // props: {
  //   'hover':{
  //   type: Number,
  //   required : true
  //   }
  // },
  data: function data() {
    return {};
  },

  components: {},
  computed: {},
  mounted: function mounted() {
    console.log();
  },
  methods: {
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Index"
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: "Index"
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: "Index"
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: "Index"
      });
    }
  }
});

/***/ }),

/***/ "ykli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 导入 Axios

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyHead",
  // props: {
  //   'hover':{
  //   type: Number,
  //   required : true
  //   }
  // },
  data: function data() {
    return {
      token: "",
      response: null,
      error: null,
      isShowLoginBtn: true
    };
  },

  components: {},
  computed: {},
  mounted: function mounted() {
    this.token = localStorage.getItem("token");
    // console.log(this.token);
    if (this.token) {
      this.CheckUserbtn();
    }
  },
  methods: {
    gotoRegTiePage: function gotoRegTiePage() {
      this.$router.push({
        name: "regTiePage"
      });
    },
    gotoHomePage: function gotoHomePage() {
      this.$router.push({
        name: "Index"
      });
    },
    gotoMyPage: function gotoMyPage() {
      this.$router.push({
        name: "Myselfpage"
      });
    },
    gotoSetPage: function gotoSetPage() {
      this.$router.push({
        name: "Setpage"
      });
    },
    gotoRankPage: function gotoRankPage() {
      this.$router.push({
        name: "orderpage"
      });
    },
    gotoShoplist: function gotoShoplist() {
      this.$router.push({
        name: "shop"
      });
    },
    gotoRegPage: function gotoRegPage() {
      this.$router.push({
        name: "regPage"
      });
    },
    gotoClublist: function gotoClublist() {
      this.$router.push({
        name: "clublist"
      });
    },
    gotoRacelist: function gotoRacelist() {
      this.$router.push({
        name: "racelist"
      });
    },
    gotoCourselist: function gotoCourselist() {
      this.$router.push({
        name: "courselist"
      });
    },
    CheckUserbtn: function CheckUserbtn() {
      this.CheckUserPostRequest();
    },
    CheckUserPostRequest: function CheckUserPostRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // 清空之前的响应和错误信息
                _this.response = null;
                _this.error = null;
                url = " https://ttserver.aizhuotice.online/api/v1/userInfo";
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, {
                  headers: {
                    "Content-Type": "application/json",
                    token: _this.token
                  }
                });

              case 6:
                response = _context.sent;

                // 处理成功响应
                _this.response = response.data; // 将返回的数据存储到组件状态
                // console.log(this.response);
                if (_this.response.code == 200) {
                  console.log("token成功");
                  _this.isShowLoginBtn = false;
                } else {
                  _this.isShowLoginBtn = true;
                }
                if (_this.response.code == 4011) {
                  // alert(this.response.message);
                  console.log(_this.response.message);
                  _this.token = "";
                  localStorage.setItem("token", "");
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                // 处理请求错误
                if (_context.t0.response) {
                  // 服务器返回了错误响应（例如 4xx 或 5xx）
                  _this.error = "\u670D\u52A1\u5668\u9519\u8BEF: " + _context.t0.response.status + " - " + _context.t0.response.statusText;
                } else if (_context.t0.request) {
                  // 请求已发出，但没有收到响应
                  _this.error = "未收到服务器响应";
                } else {
                  // 其他错误
                  _this.error = "\u8BF7\u6C42\u5931\u8D25: " + _context.t0.message;
                }
                console.log(_this.error);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    }
  }
});

/***/ }),

/***/ "yzwe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z0Kd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('myheadBlock'),_vm._v(" "),_c('div',{staticClass:"shopbox"},_vm._l((_vm.brandList),function(item2){return _c('div',{key:item2.id,staticClass:"shoplist1"},[_vm._m(0,true),_vm._v(" "),_c('swiper',{ref:"mySwiper",refInFor:true,staticClass:"shopswiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.shopitemlist[item2.id]),function(item){return _c('swiper-slide',{key:item.id},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.gotoShopDes(item.id)}}},[_c('div',{staticClass:"swiperitemimg"},[_c('img',{attrs:{"src":__webpack_require__("O1zH")}})]),_vm._v(" "),_c('div',{staticClass:"shopitemdes"},[_c('p',[_vm._v("训练课程")]),_vm._v(" "),_c('p',[_vm._v("￥"+_vm._s(item.price))])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-scrollbar",attrs:{"slot":"scrollbar"},slot:"scrollbar"})],2)],1)}),0),_vm._v(" "),(_vm.showCourseDes)?_c('div',{staticClass:"coursedesbox",on:{"click":_vm.closeCoursedesbox}},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('footerBlock')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shoptitlebox"},[_c('p',[_vm._v("康复课程")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coursedesimg"},[_c('img',{attrs:{"src":__webpack_require__("O1zH")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.11d38b22278f15faea06.js